<template>
  <!-- NOTE (TEMPLATE) to show the university profile -->

  <div class="animated fadeIn university">
    <!-- loading component -->
    <vLoading
      v-if="
        $router.currentRoute.path.indexOf('/admin/university') == 0 && vLoading
      "
    />
    <b-card
      v-if="$router.currentRoute.path.indexOf('/admin/university') == 0"
      style="border: 0"
      class="mt-0 mb-0"
    >
      <h2>پروفایل دانشگاه</h2>
      <hr />
      <b-tabs v-model="tabNumber" pills>
        <b-tab title="مشاهده" active style="padding: 0 !important">
          <v-card
            class="uni-view pa-4"
            v-if="loaded"
            :class="universityInfo.isDistinguished ? 'distinguished-class' : ''"
          >
            <v-row class="">
              <v-col cols="12" sm="12" md="12" lg="6" xl="6">
                <v-card class="common-card uni-card">
                  <v-row class="uni-header">
                    <v-col cols="12" class="d-flex flex-column flex-sm-row">
                      <div class="view-imageBox">
                        <img
                          :src="
                            universityInfo.avatar
                              ? universityInfo.avatar
                              : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTasF2J01pp5zzTcs1-GtFdrelxnu331FtNs6jNP6LRwfLdIpw0zZEB7iOOf5NoPeKb_8g&usqp=CAU'
                          "
                        />
                      </div>
                      <div class="description-box ps-5 pe-0">
                        <div class="d-flex align-items-center mb-2">
                          <img
                            v-if="universityInfo.isDistinguished"
                            class="star-icon me-2"
                            src="/icon-star.png"
                          />
                          <h5 class="mt-4 c-dark fs-xxlarge">
                            {{ universityInfo.name }}
                          </h5>
                        </div>

                        <p
                          v-if="universityInfo.description"
                          class="c-grey fs-medium text-justify"
                        >
                          {{
                            universityInfo.description.length > 180
                              ? universityInfo.description.slice(0, 180) + "..."
                              : universityInfo.description
                          }}
                        </p>
                        <div
                          v-else
                          class="c-grey fs-small"
                          style="width: 100% !important"
                        >
                          توضیحی برای دانشگاه ثبت نشده است.
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                  <div
                    v-if="universityInfo.description.length > 220"
                    class="text-left"
                  >
                    <v-btn
                      class="seeMore-btn"
                      @click="openSeeMoreModal('description')"
                      text
                    >
                      <span class="c-primary">مشاهده بیشتر</span>
                    </v-btn>
                  </div>
                </v-card>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="6" xl="6">
                <v-card class="common-card card-height">
                  <h5 class="mt-1 c-dark fs-xxlarge">اطلاعات تماس دانشگاه</h5>
                  <div class="pt-2 c-grey">
                    <v-icon class="ps-2">$Location</v-icon>
                    <span class="fs-medium">
                      نشانی دانشگاه:
                      {{
                        universityInfo.state +
                        ", " +
                        universityInfo.city +
                        (universityInfo.city ? ", " : "")
                      }}
                      {{
                        universityInfo.address ? universityInfo.address : "--"
                      }}
                    </span>
                  </div>
                  <div class="pt-4 c-grey">
                    <v-icon class="ps-2">$Phone</v-icon>
                    <span class="fs-medium">
                      تلفن‌های تماس روابط عمومی:
                      {{ universityInfo.tel ? universityInfo.tel : "--" }}
                    </span>
                  </div>
                  <div class="pt-4 c-grey">
                    <v-icon class="ps-2">$Email</v-icon>
                    <span class="fs-medium">
                      کدپستی:
                      {{
                        universityInfo.postalCode
                          ? universityInfo.postalCode
                          : "--"
                      }}
                    </span>
                  </div>
                  <div class="pt-4 c-grey">
                    <v-icon class="ps-2">$Url</v-icon>
                    <span class="fs-medium" v-if="universityInfo.website">
                      آدرس‌‌ تارنما:
                      <a :href="checkWebsite()" target="_blank">{{
                        universityInfo.website
                      }}</a>
                    </span>
                    <span class="fs-medium" v-else> آدرس‌‌ تارنما: -- </span>
                  </div>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12" lg="6" xl="6">
                <v-card class="common-card card-height">
                  <v-row class="pe-2 ps-2">
                    <v-col class="center-col">
                      <h5 class="fs-xxlarge">هیئت علمی</h5>

                      <v-spacer></v-spacer>
                      <h6 class="fs-large">
                        {{
                          universityInfo.scienceCommitteeCounts
                            ? universityInfo.scienceCommitteeCounts
                            : "0"
                        }}
                        نفر
                      </h6>
                    </v-col>
                  </v-row>
                  <v-row
                    v-if="
                      universityInfo.scienceCommittee &&
                      universityInfo.scienceCommittee.length
                    "
                  >
                    <v-col
                      cols="6"
                      sm="4"
                      md="3"
                      lg="3"
                      xl="3"
                      v-for="(
                        professor, index
                      ) in universityInfo.scienceCommittee.slice(
                        0,
                        this.scienceCommitteeSize
                      )"
                      :key="index"
                      class="text-center"
                    >
                      <img
                        class="professor-img w-100 mb-3"
                        :src="
                          professor.avatar
                            ? professor.avatar
                            : 'https://bigbangram.com/theme/img/noavatar.png'
                        "
                      />
                      <h6 class="fs-medium c-dark">{{ professor.name }}</h6>
                      <span class="c-grey fs-small">{{
                        professor.degree
                      }}</span>
                    </v-col>
                  </v-row>
                  <v-row v-else>
                    <div class="text-center mt-10 w-100">
                      <hr />
                      <span class="fs-small c-grey"
                        >عضوی به ثبت نرسیده است.</span
                      >
                      <hr />
                    </div>
                  </v-row>
                </v-card>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="6"
                xl="6"
                class="stretch-col"
              >
                <v-card class="common-card first-card">
                  <v-row>
                    <v-col class="center-col">
                      <h5 class="mt-1 fs-xlarge">
                        دانشجویان مرتبط با زیست فناوری
                      </h5>
                      <v-spacer></v-spacer>
                      <h6 class="mt-1 fs-large">
                        {{
                          universityInfo.bioStudentCounts
                            ? universityInfo.bioStudentCounts
                            : "0"
                        }}
                        نفر
                      </h6>
                    </v-col>
                  </v-row>
                </v-card>
                <v-card class="common-card second-card mt-2">
                  <v-row>
                    <v-col cols="8">
                      <h5 class="mb-4 fs-xxlarge">
                        {{ computedMehvarCardTitle }}
                      </h5>
                    </v-col>
                    <v-col class="text-left">
                      <h6 class="fs-large">
                        {{
                          universityInfo.mehvars.length +
                          universityInfo.otherMehvars.filter(
                            (x) => x.acceleratorId
                          ).length +
                          " مورد "
                        }}
                      </h6>
                    </v-col>
                  </v-row>
                  <div
                    v-if="
                      !universityInfo.mehvars.length &&
                      !universityInfo.otherMehvars.filter(
                        (x) => x.acceleratorId
                      ).length
                    "
                    class="text-center mt-12"
                  >
                    <hr />
                    <span class="fs-small c-grey"
                      >محوری به ثبت نرسیده است.</span
                    >
                    <hr />
                  </div>
                  <div v-else>
                    <div v-if="universityInfo.mehvars.length >= 3">
                      <ul class="mb-3 c-grey">
                        <li
                          v-for="(
                            mehvar, index
                          ) in universityInfo.mehvars.slice(0, 3)"
                          :key="index"
                        >
                          <v-icon>mdi-circle-medium</v-icon>

                          <span class="fs-medium">
                            {{
                              mehvar.name.length > 60
                                ? mehvar.name.slice(0, 60) + "..."
                                : mehvar.name
                            }}
                          </span>
                        </li>
                      </ul>

                      <div class="text-left pt-3">
                        <v-btn
                          class="seeMore-btn"
                          @click="openSeeMoreModal('mehvar')"
                          text
                        >
                          <span class="c-primary">مشاهده بیشتر</span>
                        </v-btn>
                      </div>
                    </div>
                    <div
                      v-else-if="
                        universityInfo.mehvars.length < 3 &&
                        universityInfo.mehvars.length != 0
                      "
                    >
                      <ul>
                        <div
                          v-for="(mehvar, index) in universityInfo.mehvars"
                          :key="index"
                          class="mb-3"
                        >
                          <li class="fs-medium c-grey">
                            <v-icon>mdi-circle-medium</v-icon>

                            {{
                              mehvar.name.length > 60
                                ? mehvar.name.slice(0, 60) + "..."
                                : mehvar.name
                            }}
                          </li>
                        </div>
                      </ul>

                      <div
                        v-if="
                          showMehvarMoreBtn ||
                          universityInfo.otherMehvars.filter(
                            (x) => x.acceleratorId
                          ).length
                        "
                        class="text-left pt-3"
                      >
                        <v-btn
                          class="seeMore-btn"
                          @click="
                            openSeeMoreModal('mehvar');
                            mehvarType = 'mehvars';
                          "
                          text
                        >
                          <span class="c-primary">مشاهده بیشتر</span>
                        </v-btn>
                      </div>
                    </div>
                    <div
                      v-else-if="
                        !universityInfo.mehvars.length &&
                        universityInfo.otherMehvars.filter(
                          (x) => x.acceleratorId
                        ).length
                      "
                      class="ms-5"
                    >
                      <ul>
                        <div
                          v-for="(
                            mehvar, index
                          ) in universityInfo.otherMehvars.filter(
                            (x) => x.acceleratorId
                          )"
                          :key="index"
                          class="mb-3"
                        >
                          <li class="fs-medium c-grey">
                            <v-icon>mdi-circle-medium</v-icon>
                            {{
                              mehvar.name.length > 70
                                ? mehvar.name.slice(0, 70) + "..."
                                : mehvar.name
                            }}
                            <span
                              v-if="mehvar.acceleratorId"
                              @click="goToAccelerator(mehvar.acceleratorId)"
                              class="pointer cyan--text text--lighten-1"
                            >
                              {{
                                "( نام‌ شتاب‌دهنده: " +
                                mehvar.acceleratorName +
                                " )"
                              }}
                            </span>
                          </li>
                        </div>
                      </ul>

                      <div class="text-left pt-3">
                        <v-btn
                          v-if="showMehvarMoreBtn"
                          class="seeMore-btn"
                          @click="
                            openSeeMoreModal('mehvar');
                            mehvarType = 'otherMehvars';
                          "
                          text
                        >
                          <span class="c-primary">مشاهده بیشتر</span>
                        </v-btn>
                      </div>
                    </div>
                  </div>
                </v-card>
              </v-col>
            </v-row>
            <v-row v-if="universityInfo.chartHasData">
              <v-col>
                <v-card class="common-card w-100">
                  <v-card-title>
                    <h5 class="fs-xxlarge">آمار حمایت‌ ها</h5>
                  </v-card-title>
                  <Chart
                    name="barChart"
                    :chartdata="universityInfo.requestDetails"
                    :options="optionsBar"
                    type="bar"
                    :height="130"
                    v-if="loaded"
                  >
                  </Chart>
                </v-card>
              </v-col>
            </v-row>
            <div v-if="universityInfo.isDistinguished">
              <v-row class="mb-3">
                <v-col cols="12" md="6">
                  <v-card class="common-card card-height mt-3">
                    <v-row>
                      <v-col>
                        <h5 class="mb-4 fs-xxlarge">
                          پروژه‌های انجام شده دانشگاه
                        </h5>
                      </v-col>
                    </v-row>
                    <div
                      v-if="!universityInfo.uniProjects"
                      class="text-center my-12"
                    >
                      <hr />
                      <span class="fs-small c-grey"
                        >توضیحی برای این قسمت ثبت نشده‌ است.</span
                      >
                      <hr />
                    </div>
                    <div v-else>
                      <!-- inja -->
                      <p
                        class="c-grey fs-medium text-justify"
                        v-html="
                          universityInfo.uniProjects.length > 350
                            ? universityInfo.uniProjects.slice(0, 350) + '...'
                            : universityInfo.uniProjects
                        "
                      ></p>

                      <div
                        v-if="universityInfo.uniProjects.length > 350"
                        class="text-left mt-8"
                      >
                        <v-btn
                          class="seeMore-btn"
                          @click="openSeeMoreModal('uniProjects')"
                          text
                        >
                          <span class="c-primary">مشاهده بیشتر</span>
                        </v-btn>
                      </div>
                    </div>
                  </v-card></v-col
                >
                <v-col cols="12" md="6">
                  <v-card class="common-card card-height mt-3">
                    <v-row>
                      <v-col>
                        <h5 class="mb-4 fs-xxlarge">
                          گرنت‌های دریافتی دانشگاه
                        </h5>
                      </v-col>
                    </v-row>
                    <div
                      v-if="!universityInfo.uniGrants"
                      class="text-center my-12"
                    >
                      <hr />
                      <span class="fs-small c-grey"
                        >توضیحی برای این قسمت ثبت نشده‌ است.</span
                      >
                      <hr />
                    </div>
                    <div v-else>
                      <p
                        class="c-grey fs-medium text-justify"
                        v-html="
                          universityInfo.uniGrants.length > 350
                            ? universityInfo.uniGrants.slice(0, 350) + '...'
                            : universityInfo.uniGrants
                        "
                      ></p>

                      <div
                        v-if="universityInfo.uniGrants.length > 350"
                        class="text-left mt-8"
                      >
                        <v-btn
                          class="seeMore-btn"
                          @click="openSeeMoreModal('uniGrants')"
                          text
                        >
                          <span class="c-primary">مشاهده بیشتر</span>
                        </v-btn>
                      </div>
                    </div>
                  </v-card></v-col
                >
              </v-row>
              <v-row>
                <v-col>
                  <v-card class="common-card mb-3">
                    <v-row>
                      <v-col>
                        <h5 class="mb-4 fs-xxlarge">توضیحات تکمیلی</h5>
                      </v-col>
                    </v-row>
                    <div
                      v-if="!universityInfo.uniFurtherDescription"
                      class="text-center my-12"
                    >
                      <hr />
                      <span class="fs-small c-grey">توضیحی ثبت نشده‌ است.</span>
                      <hr />
                    </div>
                    <div v-else>
                      <!-- inja -->
                      <p
                        class="c-grey fs-medium text-justify"
                        v-html="
                          universityInfo.uniFurtherDescription.length > 350
                            ? universityInfo.uniFurtherDescription.slice(
                                0,
                                350
                              ) + '...'
                            : universityInfo.uniFurtherDescription
                        "
                      ></p>

                      <div
                        v-if="universityInfo.uniFurtherDescription.length > 350"
                        class="text-left mt-14"
                      >
                        <v-btn
                          class="seeMore-btn"
                          @click="openSeeMoreModal('uniFurtherDescription')"
                          text
                        >
                          <span class="c-primary">مشاهده بیشتر</span>
                        </v-btn>
                      </div>
                    </div>
                  </v-card></v-col
                >
              </v-row>
            </div>
            <v-row>
              <v-col>
                <v-card class="common-card w-100">
                  <v-card-title class="px-0">
                    <h5 class="fs-xxlarge">گالری تصاویر</h5>
                  </v-card-title>
                  <div
                    v-if="
                      !universityInfo.gallery || !universityInfo.gallery.length
                    "
                    class="py-4 c-grey fs-small text-center"
                  >
                    <hr />
                    تصویری برای این دانشگاه به ثبت نرسیده است.
                    <hr />
                  </div>
                  <div v-else>
                    <v-row v-if="type != 'mobile'">
                      <v-col
                        class="text-center img-col d-flex"
                        sm="4"
                        md="4"
                        lg="2"
                        xl="2"
                        v-for="(img, index) in universityInfo.gallery.slice(
                          0,
                          6
                        )"
                        :key="index"
                      >
                        <img :src="img.url" class="gallery-img mb-2" />
                        <span class="fs-medium c-grey">{{
                          img.title.length > 20
                            ? img.title.slice(0, 20) + "..."
                            : img.title
                        }}</span>
                      </v-col>
                    </v-row>
                    <v-row class="main-div" v-if="type == 'mobile'">
                      <v-carousel
                        :show-arrows="universityInfo.gallery.length > 1"
                        v-model="model"
                        hide-delimiters
                      >
                        <v-carousel-item
                          cycle
                          v-for="(img, index) in universityInfo.gallery"
                          :key="index"
                          :src="img.url"
                          reverse-transition="fade-transition"
                          transition="fade-transition"
                          class="slider"
                        >
                        </v-carousel-item>
                      </v-carousel>
                    </v-row>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-card>
        </b-tab>
        <b-tab title="اطلاعات دانشگاه">
          <b-card style="border: 0" class="mt-0 mb-0">
            <b-row class="mb-lg-3 mb-0">
              <b-col cols="12" sm="12" md="3" lg="3">
                <div
                  tabindex="0"
                  class="imageBox"
                  @click="
                    uploading = false;
                    addLogoImage = true;
                  "
                >
                  <img
                    style="cursor: pointer"
                    :src="
                      editInfo.avatar
                        ? editInfo.avatar
                        : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTasF2J01pp5zzTcs1-GtFdrelxnu331FtNs6jNP6LRwfLdIpw0zZEB7iOOf5NoPeKb_8g&usqp=CAU'
                    "
                  />
                </div>

                <v-file-input
                  @change="logoUpload(file)"
                  v-model="file"
                  ref="logoUpload"
                  outlined
                  dense
                  v-show="false"
                ></v-file-input>
              </b-col>
              <b-col cols="12" sm="12" md="9" lg="9" class="mt-lg-2">
                <b-row class="mb-2">
                  <b-col>
                    <div class="disabled-fields grey lighten-3">
                      وضعیت:
                      {{ editInfo.status == "active" ? "فعال" : "غیر فعال" }}
                    </div>
                  </b-col>
                </b-row>
                <b-form-group
                  label="نام دانشگاه یا مرکز تحقیقات"
                  :class="editInfo.name ? 'done' : 'required'"
                >
                  <b-form-input
                    trim
                    v-model="editInfo.name"
                    type="text"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  label="نام کاربری"
                  :class="
                    editInfo.username && computedUsername ? 'done' : 'required'
                  "
                >
                  <b-form-input
                    trim
                    v-model="editInfo.username"
                    @keydown="justEng($event)"
                    type="text"
                  ></b-form-input>
                  <span
                    class="text-danger"
                    v-if="editInfo.username && !computedUsername"
                    >* استفاده از حروف الزامی است!</span
                  >
                </b-form-group>
              </b-col>
            </b-row>
            <b-form-group label="توضیحات">
              <b-form-textarea
                v-model="editInfo.description"
                placeholder="توضیحات"
                rows="3"
              ></b-form-textarea>
            </b-form-group>
            <b-row>
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 px-0">
                <b-col>
                  <b-form-group
                    label="استان"
                    :class="editInfo.stateId ? 'done' : 'required'"
                  >
                    <v-autocomplete
                      v-model="editInfo.stateId"
                      :items="iran"
                      @change="editInfo.cityId = ''"
                      item-value="id"
                      item-text="name"
                      dense
                      outlined
                      class="dropdown-style"
                      hide-details
                    ></v-autocomplete>
                  </b-form-group>
                </b-col>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 px-0">
                <b-col>
                  <b-form-group label="شهر">
                    <v-autocomplete
                      v-model="editInfo.cityId"
                      :items="
                        iran
                          .filter((x) => x.id == editInfo.stateId)
                          .map((y) => y.cities)[0]
                      "
                      item-value="id"
                      item-text="name"
                      dense
                      outlined
                      class="dropdown-style"
                      hide-details
                    ></v-autocomplete>
                  </b-form-group>
                </b-col>
              </div>
            </b-row>
            <b-form-group label="آدرس">
              <b-form-input
                trim
                v-model="editInfo.address"
                type="text"
              ></b-form-input>
            </b-form-group>
            <b-form-group label="تلفن‌های تماس روابط عمومی">
              <b-form-input trim v-model="editInfo.tel"></b-form-input>
            </b-form-group>
            <b-form-group label="کدپستی">
              <b-form-input
                trim
                v-model="editInfo.postalCode"
                :no-wheel="true"
              ></b-form-input>
            </b-form-group>
            <b-form-group label="ایمیل">
              <b-form-input
                trim
                v-model="editInfo.email"
                type="email"
                :state="validateEmail(editInfo.email) ? null : false"
                aria-describedby="email"
              ></b-form-input>
              <b-form-invalid-feedback id="email"
                >پست الکترونیک صحیح نیست</b-form-invalid-feedback
              >
            </b-form-group>
            <b-form-group label="آدرس تارنما">
              <b-form-input
                trim
                v-model="editInfo.website"
                :state="checkUrl(editInfo.website) ? null : false"
                type="url"
              ></b-form-input>
              <b-form-invalid-feedback id="url"
                >آدرس تارنما صحیح نیست</b-form-invalid-feedback
              >
            </b-form-group>
            <b-form-group label="شماره همراه رابط">
              <b-form-input
                trim
                v-model="editInfo.mobile"
                type="number"
                :no-wheel="true"
              ></b-form-input>
            </b-form-group>

            <b-form-group label="نوع دانشگاه">
              <b-form-select
                v-model="editInfo.type"
                :options="types"
              ></b-form-select>
            </b-form-group>
            <b-form-group label="معاون پژوهشی(تحقیقات و فناوری)">
              <b-form-input
                trim
                v-model="editInfo.researchAssistant"
                type="text"
              ></b-form-input>
            </b-form-group>
            <b-form-group label="تعداد اعضای هیئت علمی">
              <b-form-input
                trim
                v-model="editInfo.scienceCommitteeCounts"
                type="number"
                :no-wheel="true"
              ></b-form-input>
            </b-form-group>
            <b-form-group label="تعداد اعضای هیئت علمی مرتبط با زیست فناوری">
              <b-form-input
                trim
                v-model="editInfo.bioScienceCommitteeCounts"
                type="number"
                :no-wheel="true"
              ></b-form-input>
            </b-form-group>
            <b-form-group label="تعداد دانشجویان">
              <b-form-input
                trim
                v-model="editInfo.studentCounts"
                type="number"
                :no-wheel="true"
              ></b-form-input>
            </b-form-group>
            <b-form-group label="تعداد دانشجویان مرتبط با زیست فناوری">
              <b-form-input
                trim
                v-model="editInfo.bioStudentCounts"
                type="number"
                :no-wheel="true"
              ></b-form-input>
            </b-form-group>
            <b-form-group class="mt-8">
              <div class="d-flex">
                <b-form-checkbox v-model="editInfo.isDistinguished">
                </b-form-checkbox>
                <span class="ms-2 font-weight-bold">
                  این دانشگاه جزو دانشگاه‌های
                  <span
                    class="font-weight-bold h5 mx-1 light-blue--text text--darken-4"
                  >
                    <v-icon class="amber--text darken-2--text">mdi-star</v-icon>
                    ممتاز</span
                  >
                  است.
                </span>
              </div>
            </b-form-group>
            <div v-if="editInfo.isDistinguished">
              <div class="pa-5 blue-grey lighten-5" style="border-radius: 15px">
                <label class="font-weight-bold blue-grey--text text--darken-3"
                  >پروژه‌های انجام شده دانشگاه</label
                >
                <vue-ckeditor v-model="editInfo.uniProjects" :config="config" />
              </div>
              <div
                class="pa-5 blue-grey lighten-5 my-10"
                style="border-radius: 15px"
              >
                <label class="font-weight-bold blue-grey--text text--darken-3"
                  >گرنت‌های دریافتی دانشگاه</label
                >
                <vue-ckeditor v-model="editInfo.uniGrants" :config="config" />
              </div>
              <div class="pa-5 blue-grey lighten-5" style="border-radius: 15px">
                <label class="font-weight-bold blue-grey--text text--darken-3"
                  >توضیحات تکمیلی</label
                >
                <vue-ckeditor
                  v-model="editInfo.uniFurtherDescription"
                  :config="config"
                />
              </div>
            </div>
            <!-- NOTE (b-editProfile) to submit profile changes -->
            <v-btn
              class="bc-green btn-radius white--text mt-6 font-weight-bold"
              style="box-shadow: none !important"
              :disabled="
                isBusy ||
                !computedUsername ||
                !editInfo.username ||
                !editInfo.name ||
                !checkUrl(editInfo.website) ||
                !validateEmail(editInfo.email)
              "
              @click="submit()"
            >
              <v-icon class="me-2">mdi-check</v-icon>
              ثبت اطلاعات</v-btn
            >
          </b-card>
        </b-tab>
        <b-tab title="رابط دانشگاه">
          <b-form-group label="نام رابط">
            <b-form-input
              trim
              v-model="contanctName"
              type="text"
            ></b-form-input>
          </b-form-group>
          <b-form-group label="سمت رابط">
            <b-form-input
              trim
              v-model="contanctRole"
              type="text"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            label="شماره همراه رابط"
            label-for="contact-mobile"
            :class="isMobileValid ? 'done' : 'required'"
          >
            <b-form-input
              dir="rtl"
              trim
              v-model="contanctMobile"
              type="number"
              :disabled="notEditable"
              :state="isMobileValid"
            />
            <b-form-invalid-feedback v-if="!isMobileValid">
              شماره موبایل نامعتبر است
            </b-form-invalid-feedback>
          </b-form-group>
          <b-input-group size="md" class="mb-3">
            <!-- NOTE (b-changePass) to change the password -->
            <v-btn
              class="blue-btn"
              @click="changeContactInfo"
              :disabled="checkChangeContact"
              >ثبت</v-btn
            >
          </b-input-group>
        </b-tab>
        <b-tab title="موضوعات زیست فناوری">
          <v-btn
            @click="openAddCat()"
            style="float: right"
            class="my-2 green-btn"
            :disabled="universityCats.length == 2"
          >
            <v-icon class="me-1">mdi-plus</v-icon>
            <strong>افزودن موضوع جدید</strong></v-btn
          >
          <b-modal no-close-on-backdrop id="addCat" ref="addCat">
            <h4>افزودن موضوع جدید</h4>
            <br />
            <!-- {{categories}} -->
            <b-form-group label="موضوع مربوطه">
              <v-select
                :reduce="(x) => x.code"
                :options="
                  categories.map((x) => {
                    return {
                      code: x.id,
                      label: x.name,
                    };
                  })
                "
                v-model="universityCat"
              >
              </v-select>
            </b-form-group>
            <br />
            <br />
            <br />
            <template v-slot:modal-footer>
              <!-- NOTE (b-addMehvar3) previous -->
              <b-button
                :disabled="!universityCat"
                variant="success"
                @click="addCatUni()"
                >افزودن</b-button
              >
            </template>
          </b-modal>
          <b-modal no-close-on-backdrop id="removeCat" ref="removeCat">
            <h4>حذف موضوع</h4>
            <h5>
              آیا از حذف موضوع "{{ universityCatRemove.name }}"" مطمئن هستید؟
            </h5>
            <template v-slot:modal-footer>
              <!-- NOTE (b-addMehvar3) previous -->
              <b-button variant="danger" @click="removeCatUni()"
                >مطمئن هستم</b-button
              >
              <b-button variant="success" @click="closeRemoveCat()"
                >خیر</b-button
              >
            </template>
          </b-modal>
          <b-table
            responsive
            show-empty
            head-variant="dark"
            :fields="catFields"
            :items="universityCats"
            empty-text="موضوعی برای نمایش وجود ندارد"
            empty-filtered-text="نتیجه یافت نشد"
            striped
            :busy="fileBusy"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.index + 1 }}
              </div>
            </template>
            <template v-slot:cell(operation)="data">
              <div style="text-align: center; vertical-align: middle">
                <v-btn
                  @click="openRemoveCat(), (universityCatRemove = data.item)"
                  style="float: right"
                  class="my-2 red-btn"
                >
                  <v-icon class="me-1">mdi-note-remove-outline</v-icon>
                  <strong>حذف</strong></v-btn
                >
              </div>
            </template>
            <div slot="table-busy" class="text-center text-danger my-2">
              <strong>در حال بارگذاری...</strong>
              <br />
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </b-table>
        </b-tab>
        <b-tab title="محورهای زیست فناوری">
          <v-btn
            @click="openAdd3()"
            style="float: right"
            class="my-2 green-btn"
            disabled="true"
          >
            <v-icon class="me-1">mdi-plus</v-icon>
            <strong>افزودن محور جدید</strong></v-btn
          >
          <b-modal no-close-on-backdrop id="add3" ref="add3">
            <h4>افزودن محور جدید</h4>
            <br />
            <b-form-group>
              <b-form-input
                trim
                placeholder="نام محور"
                v-model="newMehvar"
              ></b-form-input>
            </b-form-group>
            <!-- {{categories}} -->
            <b-form-group label="موضوع مربوطه">
              <v-select
                :reduce="(x) => x.code"
                :options="
                  categories.map((x) => {
                    return {
                      code: x.id,
                      label: x.name,
                    };
                  })
                "
                v-model="newMehvarMozou"
              >
              </v-select>
            </b-form-group>

            <b-form-group>
              <b-form-input
                trim
                placeholder="شماره تفاهم‌نامه"
                v-model="newMehvarNumber"
                type="number"
              ></b-form-input>
            </b-form-group>
            <b-form-group label="تاریخ تفاهم‌نامه">
              <date-picker
                color="#7b1fa2"
                v-model="newMehvarDate"
              ></date-picker>
            </b-form-group>
            <template v-slot:modal-footer>
              <!-- NOTE (b-addMehvar3) previous -->
              <b-button
                :disabled="!newMehvar"
                variant="success"
                @click="doAdd3()"
                >افزودن</b-button
              >
            </template>
          </b-modal>
          <b-table
            responsive
            show-empty
            head-variant="dark"
            :fields="fileFields"
            :items="universityInfo.mehvars"
            empty-text="رکوردی برای نمایش وجود ندارد"
            empty-filtered-text="نتیجه یافت نشد"
            striped
            :busy="fileBusy"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.index + 1 }}
              </div>
            </template>
            <div slot="table-busy" class="text-center text-danger my-2">
              <strong>در حال بارگذاری...</strong>
              <br />
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </b-table>
        </b-tab>
        <b-tab title="هیئت علمی">
          <v-btn
            @click="openAddMemberDialog()"
            style="float: right"
            class="my-2 green-btn"
          >
            <v-icon class="me-1">mdi-plus</v-icon>
            <strong>افزودن عضو جدید</strong></v-btn
          >
          <b-table
            responsive
            show-empty
            head-variant="dark"
            :fields="memberFields"
            :items="universityInfo.scienceCommittee"
            empty-text="رکوردی برای نمایش وجود ندارد"
            striped
            :busy="fileBusy"
            :current-page="currentPage"
            :per-page="perPage"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(operation)="data">
              <div style="text-align: center; vertical-align: middle">
                <v-btn
                  color="primary"
                  class="mx-1"
                  @click="openEditMember(data.item)"
                >
                  ویرایش
                </v-btn>
                <v-btn
                  color="red"
                  class="white--text mx-1"
                  @click="openDeleteMember(data.item)"
                >
                  حذف
                </v-btn>
              </div>
            </template>
            <div slot="table-busy" class="text-center text-danger my-2">
              <strong>در حال بارگذاری...</strong>
              <br />
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </b-table>
          <v-row>
            <v-col>
              <v-pagination
                v-model="currentPage"
                :length="Math.ceil(totalRows / perPage)"
                :total-visible="5"
                prev-icon="arrow_back"
                next-icon="arrow_forward"
                class="float-end"
              ></v-pagination>
            </v-col>
          </v-row>
          <v-dialog v-model="addLogoImage" width="450">
            <v-card class="modal-card">
              <v-container class="p-4">
                <v-row class="mb-1">
                  <v-col class="text-right">
                    <h5 class="mt-1 c-dark fs-xlarge">ویرایش لوگو</h5>
                  </v-col>
                  <v-col cols="2" class="text-left">
                    <span @click="addLogoImage = false">
                      <v-icon class="pointer">mdi-close</v-icon>
                    </span>
                  </v-col>
                </v-row>
                <div v-if="!uploading">
                  <div
                    class="upload-box"
                    @dragover="dragover"
                    @dragleave="dragleave"
                    @drop="drop"
                  >
                    <p class="c-grey fs-large mb-2">
                      فایل مورد نظر را به این قسمت بکشید
                    </p>

                    <p class="c-grey fs-large mb-2">یا</p>
                    <v-btn
                      @click="$refs.logoUpload.$refs.input.click()"
                      class="c-primary b-primary bc-white"
                      elevation="0"
                      height="42"
                      >یافتن فایل</v-btn
                    >
                  </div>
                </div>
                <div v-else>
                  <div class="d-flex flex-row w-100">
                    <div class="file-icon">
                      <v-icon large>$File</v-icon>
                    </div>
                    <div class="w-100 px-3">
                      <p class="mb-0">در حال بارگذاری تصویر...</p>
                      <v-progress-linear
                        class="mt-1"
                        outlined
                        height="4"
                        :value="myFile.uploadPercentage"
                        color="#068D9D"
                      >
                      </v-progress-linear>
                    </div>
                    <div class="c-primary pt-4">
                      {{ myFile.uploadPercentage }}%
                    </div>
                  </div>
                </div>
              </v-container>
            </v-card>
          </v-dialog>
          <v-dialog v-model="addMemberDialog" width="600">
            <v-card class="addMember-modalCard pa-5">
              <v-row class="mb-1">
                <v-col class="text-right pb-0">
                  <h5 class="mt-1 c-dark fs-xxlarge">افزودن عضو جدید</h5>
                </v-col>
                <v-col class="text-left pb-0">
                  <span @click="addMemberDialog = false">
                    <v-icon class="pointer">mdi-close</v-icon>
                  </span>
                </v-col>
              </v-row>
              <div class="text-right c-grey fs-small">
                موارد ستاره‌ دار را حتما پر کنید.
              </div>
              <div class="profile-box fit-content text-center my-4">
                <img
                  :src="
                    uploadedFiles.url
                      ? uploadedFiles.url
                      : 'data:image/png;base64,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'
                  "
                />
                <div
                  @click="
                    uploading = false;
                    uploadedFiles = { url: '', id: '' };
                    addImageDialog = true;
                  "
                  class="edit-image primary pointer"
                >
                  <v-icon>$Pen</v-icon>
                </div>
              </div>
              <b-form-group label="* نام و نام خانوادگی">
                <b-form-input
                  trim
                  v-model="newMember.name"
                  type="text"
                ></b-form-input>
              </b-form-group>
              <b-form-group label="* کد ملی">
                <b-form-input
                  trim
                  v-model="newMember.natCode"
                  type="number"
                ></b-form-input>
              </b-form-group>
              <div
                v-if="!checkNatCode(newMember.natCode)"
                class="red--text fs-xsmall pt-1 mb-3"
                style="margin-top: -15px"
              >
                کد ملی وارد شده صحیح نمی‌باشد!
              </div>
              <b-form-group label="* تحصیلات">
                <b-form-input
                  trim
                  v-model="newMember.degree"
                  type="text"
                ></b-form-input>
              </b-form-group>
              <b-form-group label="* ایمیل">
                <b-form-input
                  trim
                  v-model="newMember.email"
                  type="email"
                ></b-form-input>
              </b-form-group>
              <div
                v-if="!validateEmail(newMember.email)"
                class="red--text fs-xsmall pt-1 mb-3"
                style="margin-top: -15px"
              >
                آدرس ایمیل وارد شده صحیح نمی‌باشد!
              </div>
              <v-btn
                class="c-light mt-3"
                color="primary"
                width="100"
                height="42"
                :loading="busy"
                :disabled="
                  !newMember.name ||
                  !newMember.degree ||
                  !newMember.email ||
                  !newMember.natCode ||
                  !checkNatCode(newMember.natCode) ||
                  !validateEmail(newMember.email)
                "
                @click="addMember()"
                >تایید</v-btn
              >
            </v-card>
          </v-dialog>
          <v-dialog v-model="editMemberDialog" width="600">
            <v-card class="addMember-modalCard">
              <v-container class="p-4">
                <v-row class="mb-1">
                  <v-col class="text-right pb-0">
                    <h5 class="mt-1 c-dark fs-xxlarge">ویرایش اطلاعات</h5>
                  </v-col>
                  <v-col class="text-left pb-0">
                    <span @click="editMemberDialog = false">
                      <v-icon class="pointer">mdi-close</v-icon>
                    </span>
                  </v-col>
                </v-row>
                <div class="text-right c-grey fs-small">
                  موارد ستاره‌ دار را حتما پر کنید.
                </div>
                <div class="profile-box fit-content text-center my-5">
                  <img
                    :src="
                      selectedMember.avatar
                        ? selectedMember.avatar
                        : 'data:image/png;base64,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'
                    "
                  />
                  <div
                    @click="
                      uploading = false;

                      uploadedFiles = { url: '', id: '' };
                      addImageDialog = true;
                    "
                    class="edit-image primary pointer"
                  >
                    <v-icon>$Pen</v-icon>
                  </div>
                </div>
                <b-form-group label="* نام و نام خانوادگی">
                  <b-form-input
                    trim
                    v-model="selectedMember.name"
                    type="text"
                  ></b-form-input>
                </b-form-group>
                <b-form-group label="* کد ملی">
                  <b-form-input
                    trim
                    v-model="selectedMember.natCode"
                    type="number"
                  ></b-form-input>
                </b-form-group>
                <div
                  v-if="
                    selectedMember.natCode != '-' &&
                    !checkNatCode(selectedMember.natCode)
                  "
                  class="red--text fs-xsmall pt-1 mb-3"
                  style="margin-top: -15px"
                >
                  کد ملی وارد شده صحیح نمی‌باشد!
                </div>
                <b-form-group label="* تحصیلات">
                  <b-form-input
                    trim
                    v-model="selectedMember.degree"
                    type="text"
                  ></b-form-input>
                </b-form-group>
                <b-form-group label="* ایمیل">
                  <b-form-input
                    trim
                    v-model="selectedMember.email"
                    type="email"
                  ></b-form-input>
                </b-form-group>
                <div
                  v-if="!validateEmail(selectedMember.email)"
                  class="red--text fs-xsmall pt-1 mb-3"
                  style="margin-top: -15px"
                >
                  آدرس ایمیل وارد شده صحیح نمی‌باشد!
                </div>
                <v-btn
                  class="c-light mt-4"
                  color="primary"
                  width="100"
                  height="42"
                  :loading="busy"
                  :disabled="
                    !selectedMember.name ||
                    !selectedMember.degree ||
                    !selectedMember.email ||
                    !selectedMember.natCode ||
                    (selectedMember.natCode != '-' &&
                      !checkNatCode(selectedMember.natCode)) ||
                    !validateEmail(selectedMember.email)
                  "
                  @click="editMember()"
                  >تایید</v-btn
                >
              </v-container>
            </v-card>
          </v-dialog>
          <v-dialog v-model="deleteMemberDialog" width="600">
            <v-card class="addMember-modalCard">
              <v-container class="p-4">
                <v-row class="mb-1">
                  <v-col class="text-right pb-0">
                    <h5 class="mt-1 c-dark fs-xxlarge">حذف عضو</h5>
                  </v-col>
                  <v-col class="text-left pb-0">
                    <span @click="editMemberDialog = false">
                      <v-icon class="pointer">mdi-close</v-icon>
                    </span>
                  </v-col>
                </v-row>
                <div class="mt-3 mb-6 text-center c-dark fs-large">
                  آیا از حذف "{{ selectedMember.name }}" اطمینان دارید؟
                </div>
                <div class="text-center">
                  <v-btn
                    class="primary mx-2"
                    @click="deleteMemberDialog = false"
                    >خیر</v-btn
                  >
                  <v-btn
                    :loading="busy"
                    class="red mx-2 c-light"
                    @click="deleteMember()"
                    >بله</v-btn
                  >
                </div>
              </v-container>
            </v-card>
          </v-dialog>
          <v-dialog v-model="addImageDialog" width="400">
            <v-card class="modal-card">
              <v-container class="p-4">
                <v-row class="mb-1">
                  <v-col class="text-right">
                    <h5 class="mt-1 c-dark fs-xlarge">آپلود تصویر</h5>
                  </v-col>
                  <v-col cols="2" class="text-left">
                    <span @click="addImageDialog = false">
                      <v-icon class="pointer">mdi-close</v-icon>
                    </span>
                  </v-col>
                </v-row>
                <div
                  v-if="!uploading"
                  class="upload-box"
                  @dragover="dragover"
                  @dragleave="dragleave"
                  @drop="drop"
                >
                  <p class="c-grey fs-large mb-2">
                    فایل مورد نظر را به این قسمت بکشید
                  </p>
                  <p class="c-grey fs-large mb-2">یا</p>
                  <v-btn
                    @click="$refs.uploadMemberImage.$refs.input.click()"
                    class="primary"
                    height="42"
                    >یافتن فایل</v-btn
                  >
                </div>
                <div v-else>
                  <div class="d-flex flex-row w-100">
                    <div>
                      <v-icon class="file-icon" large>$File</v-icon>
                    </div>
                    <div class="w-100 px-3">
                      <p class="mb-0">در حال برگذاری تصویر...</p>
                      <v-progress-linear
                        class="mt-1"
                        outlined
                        height="4"
                        :value="myFile.uploadPercentage"
                        color="primary"
                      >
                      </v-progress-linear>
                    </div>
                    <div class="primary--text pt-4">
                      {{ myFile.uploadPercentage }}%
                    </div>
                  </div>
                </div>
              </v-container>
            </v-card>
          </v-dialog>
        </b-tab>
        <b-tab title="تصاویر دانشگاه">
          <b-card style="border: 0" class="mt-0 mb-0">
            <div>
              <v-btn
                elevation="0"
                width="200"
                height="48"
                class="b-primary bc-white c-primary"
                @click="openAddImageModal()"
                ><v-icon>mdi-plus</v-icon> افزودن تصویر
              </v-btn>
            </div>

            <div>
              <v-row v-if="loaded" class="mt-0">
                <v-col v-if="!universityInfo.gallery.length">
                  <div class="text-center mt-8">
                    <hr />
                    تصویری ثبت نشده است.
                    <hr />
                  </div>
                </v-col>
                <v-col
                  md="4"
                  sm="6"
                  cols="12"
                  v-else
                  v-for="(item, index) in universityInfo.gallery"
                  :key="index"
                >
                  <div class="px-4">
                    <div class="gallery-imageBox">
                      <v-img :src="item.url"></v-img>
                      <div class="image-title d-flex flex-row">
                        <div>
                          {{
                            item.title.length > 25
                              ? item.title.slice(0, 25) + "..."
                              : item.title
                          }}
                        </div>
                        <v-spacer></v-spacer>
                        <div @click="openEditDialog(item)" class="pe-5">
                          <v-icon
                            class="img-icons"
                            style="transform: translateY(-1px)"
                            >$Edit</v-icon
                          >
                        </div>
                        <div @click="openDeleteDialog(item)">
                          <v-icon class="img-icons">$Trash</v-icon>
                        </div>
                      </div>
                      <div class="hover-box" @click="showBig(item)">
                        <div>
                          <v-icon>$zoomIcon</v-icon>
                          <p class="fs-large mt-2 mb-0">مشاهده</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-col>
              </v-row>
              <v-file-input
                @change="uploadImage(file)"
                v-model="file"
                ref="uploadImage"
                outlined
                dense
                v-show="false"
              ></v-file-input>
              <v-file-input
                @change="uploadMemberImage(file)"
                v-model="file"
                ref="uploadMemberImage"
                outlined
                dense
                v-show="false"
              ></v-file-input>
            </div>
            <v-dialog v-model="showImage" max-width="590">
              <v-card class="show-modalCard">
                <v-container class="text-center">
                  <div>
                    <img :src="selected.url" />
                  </div>
                  <div class="px-1 mt-4 fs-medium text-right">
                    {{ selected.title }}
                  </div>
                </v-container>
              </v-card>
            </v-dialog>
            <v-dialog v-model="deleteImage" max-width="590">
              <v-card class="delete-modalCard">
                <v-container class="text-center pa-5">
                  <div class="text-left pointer">
                    <span @click="deleteImage = false">
                      <v-icon>mdi-close</v-icon>
                    </span>
                  </div>
                  <div class="mb-5">
                    <img :src="selected.url" />
                  </div>
                  <span class="fs-medium">آیا از حذف تصویر اطمینان دارید؟</span>
                  <div class="mt-9">
                    <v-btn
                      @click="deleteImage = false"
                      elevation="0"
                      class="b-primary bc-white c-primary mx-2"
                      >لغو</v-btn
                    >
                    <v-btn
                      @click="deleteImg()"
                      elevation="0"
                      class="bc-primary c-light mx-2"
                      :loading="busy"
                      >تایید</v-btn
                    >
                  </div>
                </v-container>
              </v-card>
            </v-dialog>
            <v-dialog v-model="editImage" max-width="590">
              <v-card class="modal-card">
                <v-container class="text-center pa-5">
                  <v-row class="mb-2">
                    <v-col class="text-right c-dark fs-xxlarge">
                      ویرایش عنوان تصویر
                    </v-col>
                    <v-col class="text-left">
                      <span class="pointer" @click="editImage = false">
                        <v-icon>mdi-close</v-icon>
                      </span>
                    </v-col>
                  </v-row>
                  <div class="textField-box2 mt-4">
                    <v-text-field
                      rounded
                      outlined
                      v-model="selected.title"
                    ></v-text-field>
                  </div>
                  <div class="mt-5">
                    <v-btn
                      @click="editImage = false"
                      elevation="0"
                      class="b-primary bc-white c-primary mx-2"
                      >لغو</v-btn
                    >
                    <v-btn
                      @click="editImg()"
                      elevation="0"
                      class="bc-primary c-light mx-2"
                      :loading="busy"
                      >تایید</v-btn
                    >
                  </div>
                </v-container>
              </v-card>
            </v-dialog>
            <v-dialog v-model="addImage" width="450">
              <v-card class="modal-card">
                <v-container class="p-4">
                  <v-row class="mb-1">
                    <v-col class="text-right">
                      <h5 class="mt-1 c-dark fs-xlarge">افزودن تصویر</h5>
                    </v-col>
                    <v-col cols="2" class="text-left">
                      <span @click="addImage = false">
                        <v-icon class="pointer">mdi-close</v-icon>
                      </span>
                    </v-col>
                  </v-row>
                  <div v-if="!uploading">
                    <div class="textField-box2 pt-4 d-flex flex-row">
                      <span class="pe-4 pt-3 c-dark fs-medium"
                        >عنوان تصویر:
                      </span>
                      <div>
                        <v-text-field
                          placeholder="عنوان"
                          rounded
                          outlined
                          class="w-100"
                          v-model="title"
                        ></v-text-field>
                      </div>
                    </div>
                    <hr class="mb-7 mt-0" />
                    <div
                      class="upload-box"
                      :class="!title ? 'disabled' : ''"
                      @dragover="dragover"
                      @dragleave="dragleave"
                      @drop="drop"
                    >
                      <p class="c-grey fs-large mb-2 mt-1">
                        {{
                          title
                            ? "فایل مورد نظر را به این قسمت بکشید"
                            : "ابتدا عنوان تصویر را وارد نمایید."
                        }}
                      </p>
                      <p v-if="title" class="c-grey fs-large mb-2">یا</p>
                      <v-btn
                        v-if="title"
                        @click="$refs.uploadImage.$refs.input.click()"
                        class="c-primary b-primary bc-white"
                        elevation="0"
                        height="42"
                        >یافتن فایل</v-btn
                      >
                    </div>
                  </div>
                  <div v-else>
                    <div class="d-flex flex-row w-100">
                      <div class="file-icon">
                        <v-icon large>$File</v-icon>
                      </div>
                      <div class="w-100 px-3">
                        <p class="mb-0">در حال بارگذاری تصویر...</p>
                        <v-progress-linear
                          class="mt-1"
                          outlined
                          height="4"
                          :value="myFile.uploadPercentage"
                          color="#068D9D"
                        >
                        </v-progress-linear>
                      </div>
                      <div class="c-primary pt-4">
                        {{ myFile.uploadPercentage }}%
                      </div>
                    </div>
                  </div>
                </v-container>
              </v-card>
            </v-dialog>
          </b-card>
        </b-tab>
        <b-tab title="حمایت‌های دانشگاه">
          <b-tabs vertical pills>
            <b-tab title="طرح‌ها"
              ><b-input-group size="md" class="mb-3">
                <b-form-input
                  trim
                  v-model="projectFilter"
                  type="search"
                  id="filterInput"
                  placeholder="جستجو"
                ></b-form-input>
                <b-input-group-append>
                  <!-- NOTE (b-delete) to delete the text of the search bar -->
                  <b-button
                    :disabled="!projectFilter"
                    @click="projectFilter = ''"
                    variant="danger"
                    >حذف</b-button
                  >
                </b-input-group-append>
              </b-input-group>

              <!-- NOTE (t-universityProposals) to show the university proposals list -->
              <b-table
                responsive
                show-empty
                head-variant="dark"
                :fields="planFields"
                :items="planItems.project"
                empty-text="رکوردی برای نمایش وجود ندارد"
                empty-filtered-text="نتیجه یافت نشد"
                striped
                :busy="fileBusy2"
                :filter="projectFilter"
              >
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 }}
                  </div>
                </template>
                <template v-slot:cell(operation)="data">
                  <div style="text-align: center; vertical-align: middle">
                    <div
                      style="
                        text-align: center;
                        vertical-align: middle;
                        width: 150px;
                        margin: auto;
                      "
                    >
                      <!-- NOTE (<a>) to show the proposal details -->
                      <a
                        :href="'/admin/proposal/' + data.item.id"
                        target="_blank"
                        class="btn btn-primary text-light"
                        style="width: 100%"
                        >جزییات</a
                      >
                    </div>
                  </div>
                </template>
                <div slot="table-busy" class="text-center text-danger my-2">
                  <strong>در حال بارگذاری...</strong>
                  <br />
                  <b-spinner class="align-middle"></b-spinner>
                </div> </b-table
            ></b-tab>
            <b-tab title="رساله‌های‌ دکتری"
              ><b-input-group size="md" class="mb-3">
                <b-form-input
                  trim
                  v-model="phdFilter"
                  type="search"
                  id="filterInput"
                  placeholder="جستجو"
                ></b-form-input>
                <b-input-group-append>
                  <!-- NOTE (b-delete) to delete the text of the search bar -->
                  <b-button
                    :disabled="!phdFilter"
                    @click="phdFilter = ''"
                    variant="danger"
                    >حذف</b-button
                  >
                </b-input-group-append>
              </b-input-group>

              <!-- NOTE (t-universityProposals) to show the university proposals list -->
              <b-table
                responsive
                show-empty
                head-variant="dark"
                :fields="planFields"
                :items="planItems.phd"
                empty-text="رکوردی برای نمایش وجود ندارد"
                empty-filtered-text="نتیجه یافت نشد"
                striped
                :busy="fileBusy2"
                :filter="phdFilter"
              >
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 }}
                  </div>
                </template>
                <template v-slot:cell(operation)="data">
                  <div style="text-align: center; vertical-align: middle">
                    <div
                      style="
                        text-align: center;
                        vertical-align: middle;
                        width: 150px;
                        margin: auto;
                      "
                    >
                      <!-- NOTE (<a>) to show the proposal details -->
                      <a
                        :href="'/admin/phdProposal/' + data.item.id"
                        target="_blank"
                        class="btn btn-primary text-light"
                        style="width: 100%"
                        >جزییات</a
                      >
                    </div>
                  </div>
                </template>
                <div slot="table-busy" class="text-center text-danger my-2">
                  <strong>در حال بارگذاری...</strong>
                  <br />
                  <b-spinner class="align-middle"></b-spinner>
                </div> </b-table
            ></b-tab>
            <b-tab title="پایان‌نامه‌های ارشد"
              ><b-input-group size="md" class="mb-3">
                <b-form-input
                  trim
                  v-model="masterFilter"
                  type="search"
                  id="filterInput"
                  placeholder="جستجو"
                ></b-form-input>
                <b-input-group-append>
                  <!-- NOTE (b-delete) to delete the text of the search bar -->
                  <b-button
                    :disabled="!masterFilter"
                    @click="masterFilter = ''"
                    variant="danger"
                    >حذف</b-button
                  >
                </b-input-group-append>
              </b-input-group>

              <!-- NOTE (t-universityProposals) to show the university proposals list -->
              <b-table
                responsive
                show-empty
                head-variant="dark"
                :fields="planFields"
                :items="planItems.master"
                empty-text="رکوردی برای نمایش وجود ندارد"
                empty-filtered-text="نتیجه یافت نشد"
                striped
                :busy="fileBusy2"
                :filter="masterFilter"
              >
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 }}
                  </div>
                </template>
                <template v-slot:cell(operation)="data">
                  <div style="text-align: center; vertical-align: middle">
                    <div
                      style="
                        text-align: center;
                        vertical-align: middle;
                        width: 150px;
                        margin: auto;
                      "
                    >
                      <!-- NOTE (<a>) to show the proposal details -->
                      <a
                        :href="'/admin/masterProposal/' + data.item.id"
                        target="_blank"
                        class="btn btn-primary text-light"
                        style="width: 100%"
                        >جزییات</a
                      >
                    </div>
                  </div>
                </template>
                <div slot="table-busy" class="text-center text-danger my-2">
                  <strong>در حال بارگذاری...</strong>
                  <br />
                  <b-spinner class="align-middle"></b-spinner>
                </div> </b-table
            ></b-tab>
            <b-tab title="مقاله‌ها"
              ><b-input-group size="md" class="mb-3">
                <b-form-input
                  trim
                  v-model="articleFilter"
                  type="search"
                  id="filterInput"
                  placeholder="جستجو"
                ></b-form-input>
                <b-input-group-append>
                  <!-- NOTE (b-delete) to delete the text of the search bar -->
                  <b-button
                    :disabled="!articleFilter"
                    @click="articleFilter = ''"
                    variant="danger"
                    >حذف</b-button
                  >
                </b-input-group-append>
              </b-input-group>

              <!-- NOTE (t-universityProposals) to show the university proposals list -->
              <b-table
                responsive
                show-empty
                head-variant="dark"
                :fields="planFields"
                :items="planItems.article"
                empty-text="رکوردی برای نمایش وجود ندارد"
                empty-filtered-text="نتیجه یافت نشد"
                striped
                :busy="fileBusy2"
                :filter="articleFilter"
              >
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 }}
                  </div>
                </template>
                <template v-slot:cell(operation)="data">
                  <div style="text-align: center; vertical-align: middle">
                    <div
                      style="
                        text-align: center;
                        vertical-align: middle;
                        width: 150px;
                        margin: auto;
                      "
                    >
                      <!-- NOTE (<a>) to show the proposal details -->
                      <a
                        :href="'/admin/article/' + data.item.id"
                        target="_blank"
                        class="btn btn-primary text-light"
                        style="width: 100%"
                        >جزییات</a
                      >
                    </div>
                  </div>
                </template>
                <div slot="table-busy" class="text-center text-danger my-2">
                  <strong>در حال بارگذاری...</strong>
                  <br />
                  <b-spinner class="align-middle"></b-spinner>
                </div> </b-table
            ></b-tab>
            <b-tab title="فرصت‌های مطالعاتی"
              ><b-input-group size="md" class="mb-3">
                <b-form-input
                  trim
                  v-model="opportuneFilter"
                  type="search"
                  id="filterInput"
                  placeholder="جستجو"
                ></b-form-input>
                <b-input-group-append>
                  <!-- NOTE (b-delete) to delete the text of the search bar -->
                  <b-button
                    :disabled="!opportuneFilter"
                    @click="opportuneFilter = ''"
                    variant="danger"
                    >حذف</b-button
                  >
                </b-input-group-append>
              </b-input-group>

              <!-- NOTE (t-universityProposals) to show the university proposals list -->
              <b-table
                responsive
                show-empty
                head-variant="dark"
                :fields="planFields"
                :items="planItems.opportune"
                empty-text="رکوردی برای نمایش وجود ندارد"
                empty-filtered-text="نتیجه یافت نشد"
                striped
                :busy="fileBusy2"
                :filter="opportuneFilter"
              >
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 }}
                  </div>
                </template>
                <template v-slot:cell(operation)="data">
                  <div style="text-align: center; vertical-align: middle">
                    <div
                      style="
                        text-align: center;
                        vertical-align: middle;
                        width: 150px;
                        margin: auto;
                      "
                    >
                      <!-- NOTE (<a>) to show the proposal details -->
                      <a
                        :href="'/admin/opportunity/' + data.item.id"
                        target="_blank"
                        class="btn btn-primary text-light"
                        style="width: 100%"
                        >جزییات</a
                      >
                    </div>
                  </div>
                </template>
                <div slot="table-busy" class="text-center text-danger my-2">
                  <strong>در حال بارگذاری...</strong>
                  <br />
                  <b-spinner class="align-middle"></b-spinner>
                </div> </b-table
            ></b-tab>
            <b-tab title="نشست‌های تخصصی"
              ><b-input-group size="md" class="mb-3">
                <b-form-input
                  trim
                  v-model="meetingFilter"
                  type="search"
                  id="filterInput"
                  placeholder="جستجو"
                ></b-form-input>
                <b-input-group-append>
                  <!-- NOTE (b-delete) to delete the text of the search bar -->
                  <b-button
                    :disabled="!meetingFilter"
                    @click="meetingFilter = ''"
                    variant="danger"
                    >حذف</b-button
                  >
                </b-input-group-append>
              </b-input-group>

              <!-- NOTE (t-universityProposals) to show the university proposals list -->
              <b-table
                responsive
                show-empty
                head-variant="dark"
                :fields="planFields"
                :items="planItems.meeting"
                empty-text="رکوردی برای نمایش وجود ندارد"
                empty-filtered-text="نتیجه یافت نشد"
                striped
                :busy="fileBusy2"
                :filter="meetingFilter"
              >
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 }}
                  </div>
                </template>
                <template v-slot:cell(operation)="data">
                  <div style="text-align: center; vertical-align: middle">
                    <div
                      style="
                        text-align: center;
                        vertical-align: middle;
                        width: 150px;
                        margin: auto;
                      "
                    >
                      <!-- NOTE (<a>) to show the proposal details -->
                      <a
                        :href="'/admin/meeting/' + data.item.id"
                        target="_blank"
                        class="btn btn-primary text-light"
                        style="width: 100%"
                        >جزییات</a
                      >
                    </div>
                  </div>
                </template>
                <div slot="table-busy" class="text-center text-danger my-2">
                  <strong>در حال بارگذاری...</strong>
                  <br />
                  <b-spinner class="align-middle"></b-spinner>
                </div> </b-table
            ></b-tab>
            <b-tab title="پسا دکتری"
              ><b-input-group size="md" class="mb-3">
                <b-form-input
                  trim
                  v-model="postDocFilter"
                  type="search"
                  id="filterInput"
                  placeholder="جستجو"
                ></b-form-input>
                <b-input-group-append>
                  <!-- NOTE (b-delete) to delete the text of the search bar -->
                  <b-button
                    :disabled="!postDocFilter"
                    @click="postDocFilter = ''"
                    variant="danger"
                    >حذف</b-button
                  >
                </b-input-group-append>
              </b-input-group>

              <!-- NOTE (t-universityProposals) to show the university proposals list -->
              <b-table
                responsive
                show-empty
                head-variant="dark"
                :fields="planFields"
                :items="planItems.postDoc"
                empty-text="رکوردی برای نمایش وجود ندارد"
                empty-filtered-text="نتیجه یافت نشد"
                striped
                :busy="fileBusy2"
                :filter="postDocFilter"
              >
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 }}
                  </div>
                </template>
                <template v-slot:cell(operation)="data">
                  <div style="text-align: center; vertical-align: middle">
                    <div
                      style="
                        text-align: center;
                        vertical-align: middle;
                        width: 150px;
                        margin: auto;
                      "
                    >
                      <!-- NOTE (<a>) to show the proposal details -->
                      <a
                        :href="'/admin/postDoc/' + data.item.id"
                        target="_blank"
                        class="btn btn-primary text-light"
                        style="width: 100%"
                        >جزییات</a
                      >
                    </div>
                  </div>
                </template>
                <div slot="table-busy" class="text-center text-danger my-2">
                  <strong>در حال بارگذاری...</strong>
                  <br />
                  <b-spinner class="align-middle"></b-spinner>
                </div> </b-table
            ></b-tab>
            <b-tab title="نخبگان وظیفه"
              ><b-input-group size="md" class="mb-3">
                <b-form-input
                  trim
                  v-model="eliteFilter"
                  type="search"
                  id="filterInput"
                  placeholder="جستجو"
                ></b-form-input>
                <b-input-group-append>
                  <!-- NOTE (b-delete) to delete the text of the search bar -->
                  <b-button
                    :disabled="!eliteFilter"
                    @click="eliteFilter = ''"
                    variant="danger"
                    >حذف</b-button
                  >
                </b-input-group-append>
              </b-input-group>

              <!-- NOTE (t-universityProposals) to show the university proposals list -->
              <b-table
                responsive
                show-empty
                head-variant="dark"
                :fields="planFields"
                :items="planItems.elite"
                empty-text="رکوردی برای نمایش وجود ندارد"
                empty-filtered-text="نتیجه یافت نشد"
                striped
                :busy="fileBusy2"
                :filter="eliteFilter"
              >
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 }}
                  </div>
                </template>
                <template v-slot:cell(operation)="data">
                  <div style="text-align: center; vertical-align: middle">
                    <div
                      style="
                        text-align: center;
                        vertical-align: middle;
                        width: 150px;
                        margin: auto;
                      "
                    >
                      <!-- NOTE (<a>) to show the proposal details -->
                      <a
                        :href="'/admin/Elite/' + data.item.id"
                        target="_blank"
                        class="btn btn-primary text-light"
                        style="width: 100%"
                        >جزییات</a
                      >
                    </div>
                  </div>
                </template>
                <div slot="table-busy" class="text-center text-danger my-2">
                  <strong>در حال بارگذاری...</strong>
                  <br />
                  <b-spinner class="align-middle"></b-spinner>
                </div> </b-table
            ></b-tab>
          </b-tabs>
        </b-tab>

        <b-tab title="تغییر رمز عبور">
          <b-form-group label="رمز عبور">
            <b-form-input
              trim
              v-model="uniPassword"
              type="password"
              @input="passStrength"
              autocomplete="new-password"
            ></b-form-input>
          </b-form-group>
          <!--============== checking password =========== -->
          <b-row class="w-50">
            <b-col>
              <!-- NOTE check if the pass has more than 8 charector -->
              <p
                class="pass"
                :class="{ 'pass--passed': uniPassword.length > 7 }"
              >
                <i
                  class="frmIcon fa"
                  :class="uniPassword.length > 7 ? 'fa-check' : 'fa-times'"
                ></i>
                حداقل ۸ نویسه
              </p>
            </b-col>
            <b-col>
              <!-- NOTE check if the pass has uppercase -->
              <p class="pass" :class="{ 'pass--passed': has_uppercase }">
                <i
                  class="frmIcon fa"
                  :class="has_uppercase ? 'fa-check' : 'fa-times'"
                ></i>
                دارای حروف بزرگ باشد
              </p>
            </b-col>
          </b-row>
          <b-row class="w-50">
            <b-col>
              <!-- NOTE check if the pass has lowercase -->
              <p class="pass" :class="{ 'pass--passed': has_lowercase }">
                <i
                  class="frmIcon fa"
                  :class="has_lowercase ? 'fa-check' : 'fa-times'"
                ></i>
                دارای حروف کوچک باشد
              </p>
            </b-col>
            <b-col>
              <!-- NOTE check if the pass has number -->
              <p class="pass" :class="{ 'pass--passed': has_number }">
                <i
                  class="frmIcon fa"
                  :class="has_number ? 'fa-check' : 'fa-times'"
                ></i>
                دارای عدد باشد
              </p>
            </b-col>
          </b-row>

          <!--============== checking password =========== -->
          <b-form-group label="تکرار رمز عبور">
            <b-form-input
              trim
              v-model="uniRepeatPassword"
              type="password"
              aria-describedby="repeat-password"
              :state="checkPassword"
            ></b-form-input>
            <b-form-invalid-feedback id="repeat-password"
              >رمز عبور با تکرار آن همخوانی ندارد</b-form-invalid-feedback
            >
          </b-form-group>
          <b-input-group size="md" class="mb-3">
            <!-- NOTE (b-changePass) to change the password -->
            <v-btn
              class="blue-btn"
              @click="changePassword"
              :disabled="isBusy || checkPassword == false"
              >تغییر رمز</v-btn
            >
          </b-input-group>
        </b-tab>
      </b-tabs>
    </b-card>
    <v-dialog v-model="seeMoreModal" width="600">
      <v-card
        v-if="seeMoreType == 'description'"
        class="modal-card"
        :class="universityInfo.isDistinguished ? 'dark-modal' : ''"
      >
        <v-container class="p-4">
          <v-row class="mb-1">
            <v-col class="text-right">
              <h5 class="mt-1 c-dark fs-xxlarge">
                {{ universityInfo.name }}
              </h5>
            </v-col>
            <v-col cols="2" class="text-left">
              <span @click="seeMoreModal = false">
                <v-icon class="pointer">$Close</v-icon>
              </span>
            </v-col>
          </v-row>

          <p class="c-grey fs-medium text-justify" style="line-height: 30px">
            {{ universityInfo.description }}
          </p>
        </v-container>
      </v-card>
      <v-card
        v-else-if="seeMoreType == 'uniProjects'"
        class="modal-card"
        :class="universityInfo.isDistinguished ? 'dark-modal' : ''"
      >
        <v-container class="p-4">
          <v-row class="mb-1">
            <v-col class="text-right">
              <h5 class="mt-1 c-dark fs-xxlarge">
                پروژه‌های انجام شده دانشگاه
              </h5>
            </v-col>
            <v-col cols="2" class="text-left">
              <span @click="seeMoreModal = false">
                <v-icon class="pointer">$Close</v-icon>
              </span>
            </v-col>
          </v-row>

          <p
            class="c-grey fs-medium text-justify"
            style="line-height: 30px"
            v-html="universityInfo.uniProjects"
          ></p>
        </v-container>
      </v-card>
      <v-card
        v-else-if="seeMoreType == 'uniGrants'"
        class="modal-card"
        :class="universityInfo.isDistinguished ? 'dark-modal' : ''"
      >
        <v-container class="p-4">
          <v-row class="mb-1">
            <v-col class="text-right">
              <h5 class="mt-1 c-dark fs-xxlarge">گرنت‌های دریافتی دانشگاه</h5>
            </v-col>
            <v-col cols="2" class="text-left">
              <span @click="seeMoreModal = false">
                <v-icon class="pointer">$Close</v-icon>
              </span>
            </v-col>
          </v-row>

          <p
            class="c-grey fs-medium text-justify"
            style="line-height: 30px"
            v-html="universityInfo.uniGrants"
          ></p>
        </v-container>
      </v-card>
      <v-card
        v-else-if="seeMoreType == 'uniFurtherDescription'"
        class="modal-card"
        :class="universityInfo.isDistinguished ? 'dark-modal' : ''"
      >
        <v-container class="p-4">
          <v-row class="mb-1">
            <v-col class="text-right">
              <h5 class="mt-1 c-dark fs-xxlarge">توضیحات تکمیلی</h5>
            </v-col>
            <v-col cols="2" class="text-left">
              <span @click="seeMoreModal = false">
                <v-icon class="pointer">$Close</v-icon>
              </span>
            </v-col>
          </v-row>

          <p
            class="c-grey fs-medium text-justify"
            style="line-height: 30px"
            v-html="universityInfo.uniFurtherDescription"
          ></p>
        </v-container>
      </v-card>
      <v-card
        v-else-if="seeMoreType == 'mehvar'"
        class="modal-card"
        :class="universityInfo.isDistinguished ? 'dark-modal' : ''"
      >
        <v-container class="p-4">
          <v-row class="mb-1">
            <v-col class="text-right">
              <h5 class="mt-1 c-dark fs-xxlarge">محورهای طرح تقسیم کار ملی</h5>
            </v-col>
            <v-col cols="2" class="text-left">
              <span @click="seeMoreModal = false">
                <v-icon class="pointer">$Close</v-icon>
              </span>
            </v-col>
          </v-row>
          <div
            v-if="!universityInfo.mehvars.length"
            class="py-4 c-grey fs-small text-center"
          >
            <hr />
            محوری به ثبت نرسیده است.
            <hr />
          </div>
          <div v-else class="mehvars-box">
            <div
              v-for="(mehvar, index) in universityInfo.mehvars"
              :key="index"
              class="mb-3"
            >
              <span class="c-grey fs-medium">
                <v-icon class="c-grey">mdi-circle-medium</v-icon>
                {{ " " + mehvar.name }}
              </span>
            </div>
            <div
              v-if="
                universityInfo.otherMehvars.filter((x) => x.acceleratorId)
                  .length
              "
            >
              <hr />
              <h5 class="c-dark fs-large mt-6">همکاری با شتاب‌دهنده ها</h5>
              <div class="mehvars-box mt-6">
                <div
                  v-for="(mehvar, index) in universityInfo.otherMehvars.filter(
                    (x) => x.acceleratorId
                  )"
                  :key="index"
                  class="mb-5"
                >
                  <span class="c-grey fs-medium">
                    <v-icon class="pt-1 c-grey">mdi-circle-medium</v-icon>
                    {{ " " + mehvar.name }}
                  </span>
                  <span
                    v-if="mehvar.acceleratorId"
                    @click="goToAccelerator(mehvar.acceleratorId)"
                    class="pointer cyan--text text--lighten-1"
                  >
                    {{ "( نام‌ شتاب‌دهنده: " + mehvar.acceleratorName + " )" }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </v-container>
      </v-card>
    </v-dialog>
    <router-view></router-view>
  </div>
</template>

<script>
import utilities from "../../mixins/utilities"; // REVIEW
import VuePersianDatetimePicker from "vue-persian-datetime-picker"; // NOTE (IMPORT) date selection tool for persian date & time
import md5 from "js-md5";
import Chart from "/src/components/charts/Chart.vue";
import validator from "validator";
import isURL from "validator/lib/isURL";
import VueCkeditor from "vue-ckeditor2";

function checkCodeMeli(code) {
  //NOTE employee's checking validation of national code
  var L = code.length;

  if (L < 8 || parseInt(code, 10) == 0) return false;
  code = ("0000" + code).substr(L + 4 - 10);
  if (parseInt(code.substr(3, 6), 10) == 0) return false;
  var c = parseInt(code.substr(9, 1), 10);
  var s = 0;
  for (var i = 0; i < 9; i++) s += parseInt(code.substr(i, 1), 10) * (10 - i);
  s = s % 11;
  return (s < 2 && c == s) || (s >= 2 && c == 11 - s);
}

export default {
  components: {
    datePicker: VuePersianDatetimePicker,
    Chart,
    isURL,
    validator,
    VueCkeditor,
  },
  mixins: [utilities], // REVIEW
  data() {
    return {
      uploadedFiles: {
        url: "",
        id: "",
      },
      categories: [],
      universityInfo: {},
      editInfo: {},
      universityOtherInfo: {},
      uniPassword: "",
      iran: [],
      uniRepeatPassword: "",
      types: [
        {
          value: "پژوهشگاه و مراکز تحقیقاتی",
          text: "پژوهشگاه و مراکز تحقیقاتی",
        },
        {
          value: "دانشگاه‌های وابسته به وزارت علوم تحقیقات فناوری",
          text: "دانشگاه‌های وابسته به وزارت علوم تحقیقات فناوری",
        },
        {
          value: "دانشگاه‌های علوم پزشکی وزارت بهداشت درمان و آموزش پزشکی",
          text: "دانشگاه‌های علوم پزشکی وزارت بهداشت درمان و آموزش پزشکی",
        },
        {
          value: "سایر",
          text: "سایر",
        },
      ],
      states: [
        { value: "فعال", eng: "active", text: "فعال" },
        { value: "غیرفعال", eng: "deactive", text: "غیرفعال" },
      ],
      fileFields: [
        { key: "index", label: "#" },
        { key: "name", label: "محور" },
        { key: "date", label: "تاریخ تفاهم‌نامه" },
        { key: "contractNo", label: "شماره تفاهم‌نامه" },
      ],
      catFields: [
        { key: "index", label: "#" },
        { key: "name", label: "موضوع" },
        { key: "mainCat", label: "رسته" },
        { key: "operation", label: "مدیریت" },
      ],
      memberFields: [
        // { key: "index", label: "#" },
        { key: "name", label: "نام و نام خانوادگی" },
        { key: "natCode", label: "کد ملی" },
        { key: "degree", label: "تحصیلات" },
        { key: "email", label: "ایمیل" },
        { key: "operation", label: "عملیات" },
      ],
      fileItems: [],
      planFields: [
        { key: "index", label: "#" },
        { key: "faSubject", label: "عنوان فارسی" },
        { key: "requestsCode", label: "کد طرح" },
        { key: "status", label: "وضعیت" },
        { key: "lastUpdate", label: "آخرین بروزرسانی" },
        { key: "operation", label: "عملیات" },
      ],
      planItems: [],
      fileFilter: "",
      projectFilter: "",
      phdFilter: "",
      eliteFilter: "",
      articleFilter: "",
      postDocFilter: "",
      meetingFilter: "",
      opportuneFilter: "",
      masterFilter: "",
      fileBusy: true,
      fileFilter2: "",
      fileBusy2: true,
      isBusy: false,
      isBusy3: true,
      newMehvar: "",
      newMehvarMozou: "",
      newMehvarUniversity: "",
      newMehvarNumber: "",
      newMehvarDate: "",
      universities: [],
      has_number: false,
      has_lowercase: false,
      has_uppercase: false,
      isLoaded: true,
      addImage: false,
      editImage: false,
      uploading: false,
      deleteImage: false,
      showImage: false,
      title: "",
      vLoading: false,
      uploadPercentage: 0,
      isUploaded: false,
      file: [],
      myFile: new Object({
        uploadPercentage: 0,
      }),
      tabNumber: 0,
      selected: {},
      addLogoImage: false,
      loaded: false,
      busy: false,
      addMemberDialog: false,
      newMember: {},
      selectedMember: {},
      addImageDialog: false,
      editMemberDialog: false,
      deleteMemberDialog: false,
      type: "",
      currentPage: 1,
      totalRows: 1,
      perPage: 10,
      scienceCommitteeSize: "",
      optionsBar: {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          legend: {
            rtl: true,
            display: true,
            position: "right",
            labels: {
              font: {
                family: "iransans",
              },
              boxWidth: 24,
              boxHeight: 24,
              usePointStyle: true,
              pointStyle: "circle",
            },
          },
          tooltip: {
            titleFont: {
              family: "iransans",
            },
            bodyFont: {
              family: "iransans",
            },
          },
        },

        title: {
          display: true,
          fontSize: 16,
          position: "top",
          text: "",
        },

        scales: {
          y: {
            scaleLabel: {
              display: true,
              labelString: "",
            },
            ticks: {
              stepSize: 1,
              beginAtZero: true,
              font: { family: "iransans" },
            },
            stacked: true,
          },
          x: {
            stacked: true,
            ticks: {
              font: {
                family: "iransans",
              },
            },
          },
        },
      },
      seeMoreType: "",
      seeMoreModal: false,
      model: 0,
      config: {
        toolbar: [
          [
            "Bold",
            "Italic",
            "Underline",
            "Strike",
            "JustifyLeft",
            "JustifyCenter",
            "JustifyRight",
            "Font",
          ],
        ],
      },
      mehvarType: "mehvars",
      universityCats: [],
      universityCat: "",
      universityCatRemove: "",
      contanctName: "",
      contanctRole: "",
      contanctMobile: "",
    };
  },
  computed: {
    isMobileValid() {
      const regex = /^09\d{9}$/;
      return regex.test(this.contanctMobile);
    },
    checkChangeContact() {
      if (this.isBusy) return true;
      else {
        if (!this.contanctName) return true;
        else if (!this.contanctRole) return true;
        else if (!this.isMobileValid) return true;
        else return false;
      }
    },
    computedMehvarCardTitle() {
      if (
        !this.universityInfo.otherMehvars.filter((x) => x.acceleratorId).length
      ) {
        return "محورهای طرح تقسیم کار ملی";
      } else if (
        this.universityInfo.otherMehvars.filter((x) => x.acceleratorId)
          .length &&
        !this.universityInfo.mehvars.length
      ) {
        return "محور‌های همکاری شده با شتاب‌دهنده";
      } else {
        return "محورهای طرح تقسیم کار ملی";
      }
    },
    checkPassword() {
      // NOTE (c-checkPass) to check that the password is not duplicate
      return this.uniPassword == this.uniRepeatPassword ? null : false;
    },
    computedUsername() {
      if (!/^[a-zA-Z]+$/.test(this.universityInfo.username)) {
        if (/^[0-9]+$/.test(this.universityInfo.username)) {
          return false;
        } else {
          return true;
        }
      } else return true;
    },
    showMehvarMoreBtn() {
      let temp;
      temp = this.universityInfo[this.mehvarType].filter(
        (x) => x.name.length > 40
      );
      if (temp.length) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    goToAccelerator(id) {
      let link = "";
      link = "/acceleratorProfile/" + id;
      window.open(link, "_blank");
    },
    openSeeMoreModal(type) {
      this.seeMoreType = type;
      this.seeMoreModal = true;
    },
    checkUrl(url) {
      if (this.editInfo.website) {
        if (validator.isURL(url)) {
          return true;
        } else {
          return false;
        }
      } else return true;
    },
    checkWebsite() {
      if (
        this.universityInfo.website.indexOf("http://") == 0 ||
        this.universityInfo.website.indexOf("https://") == 0
      ) {
        return this.universityInfo.website;
      } else {
        return "//" + this.universityInfo.website;
      }
    },
    checkNatCode(id) {
      // NOTE (m-isID) to check the validity of the national code
      return id ? (checkCodeMeli(id) ? true : false) : true;
    },
    openAddImageModal() {
      this.uploading = false;
      this.title = "";
      this.addImage = true;
    },
    openDeleteDialog(item) {
      this.selected = item;
      this.deleteImage = true;
    },
    openEditDialog(item) {
      this.selected = JSON.parse(JSON.stringify(item));
      this.editImage = true;
    },
    showBig(item) {
      this.selected = item;
      this.showImage = true;
    },
    deleteImg() {
      this.busy = true;
      this.$http
        .post(
          this.baseUrl + "/setad/admin/university/removeGallery",
          {
            universityId: this.$route.params.id,
            fileId: this.selected.id,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.busy = false;
          this.toast(res.data, "success");
          this.deleteImage = false;
          this.update();
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    openEditMember(item) {
      this.selectedMember = JSON.parse(JSON.stringify(item));
      this.editMemberDialog = true;
    },
    openDeleteMember(item) {
      this.selectedMember = item;
      this.deleteMemberDialog = true;
    },
    deleteMember() {
      this.busy = true;
      this.$http
        .post(
          this.baseUrl + "/setad/admin/university/removeScienceCommittee",
          {
            universityId: this.$route.params.id,
            scienceCommitteeId: this.selectedMember.id,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.busy = false;
          this.toast(res.data, "success");
          this.deleteMemberDialog = false;
          this.update();
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    logoUpload(file) {
      // NOTE (m-myUpload) to upload files
      let sizeMB = file.size / 1024 / 1024;

      if (sizeMB > 5) {
        this.toast(
          "حجم فایل " + file.name + " نباید از 5 مگابایت بیشتر باشد",
          "error"
        );
        return;
      } else if (file.type != "image/jpeg" && file.type != "image/png") {
        this.toast("فرمت فایل مورد نظر مجاز نمی‌باشد. ", "error");
        return;
      } else {
        this.uploading = true;
        this.changeProfile = false;
        this.myFile.showProgress = true;
        this.myFile.variant = "info";
        this.myFile.uploadPercentage = 0;
        this.myFile.isUploaded = false;
        this.myFile.uploadButDisable = true;
        var formData = new FormData();
        formData.append(file.name, file);
        this.$http
          .post(
            this.baseUrl +
              "/setad/admin/university/avatar?universityId=" +
              this.$route.params.id,
            formData,
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
              onUploadProgress: ((progressEvent) => {
                this.myFile.uploadPercentage =
                  Math.round(
                    (progressEvent.loaded * 100) / progressEvent.total
                  ) - 1;
              }).bind(this),
            }
          )
          .then((d) => {
            if (d.status == 200) {
              this.myFile.isUploaded = true;
              this.myFile.uploadPercentage = 100;
              this.myFile.striped = false;
              this.myFile.variant = "success";
              this.myFile.uploadButDisable = false;
              this.toast("تصویر با موفقیت افزوده شد.", "success");

              this.addLogoImage = false;
              this.update();
            }
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
          });
      }
    },
    uploadImage(file) {
      // NOTE (m-myUpload) to upload files
      let sizeMB = file.size / 1024 / 1024;

      if (sizeMB > 5) {
        this.toast(
          "حجم فایل " + file.name + " نباید از 5 مگابایت بیشتر باشد",
          "error"
        );
        return;
      } else if (file.type != "image/jpeg" && file.type != "image/png") {
        this.toast("فرمت فایل مورد نظر مجاز نمی‌باشد. ", "error");
        return;
      } else {
        this.uploading = true;
        this.changeProfile = false;
        this.myFile.showProgress = true;
        this.myFile.variant = "info";
        this.myFile.uploadPercentage = 0;
        this.myFile.isUploaded = false;
        this.myFile.uploadButDisable = true;
        var formData = new FormData();
        formData.append(file.name, file);

        this.$http
          .post(
            this.baseUrl +
              "/setad/admin/university/addGallery?universityId=" +
              this.$route.params.id +
              "&&title=" +
              this.title,
            formData,
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
              onUploadProgress: ((progressEvent) => {
                this.myFile.uploadPercentage =
                  Math.round(
                    (progressEvent.loaded * 100) / progressEvent.total
                  ) - 1;
              }).bind(this),
            }
          )
          .then((d) => {
            if (d.status == 200) {
              this.myFile.isUploaded = true;
              this.myFile.uploadPercentage = 100;
              this.myFile.striped = false;
              this.myFile.variant = "success";
              this.myFile.uploadButDisable = false;
              this.toast("تصویر با موفقیت افزوده شد.", "success");

              setTimeout(() => {
                this.addImage = false;
                this.update();
              }, 200);
            }
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
          });
      }
    },
    uploadMemberImage(file) {
      // NOTE (m-myUpload) to upload files
      let sizeMB = file.size / 1024 / 1024;
      if (sizeMB > 5) {
        this.toast(
          "حجم فایل " + file.name + " نباید از 5 مگابایت بیشتر باشد",
          "error"
        );
        return;
      } else if (file.type != "image/jpeg" && file.type != "image/png") {
        this.toast("فرمت فایل مورد نظر مجاز نمی‌باشد. ", "error");
        return;
      } else {
        this.uploading = true;
        this.myFile.showProgress = true;
        this.myFile.variant = "info";
        this.myFile.uploadPercentage = 0;
        this.myFile.isUploaded = false;
        this.myFile.uploadButDisable = true;
        var formData = new FormData();
        formData.append(file.name, file);

        this.$http
          .post(
            this.baseUrl +
              "/setad/admin/university/upload?universityId=" +
              this.$route.params.id,
            formData,
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
              onUploadProgress: ((progressEvent) => {
                this.myFile.uploadPercentage =
                  Math.round(
                    (progressEvent.loaded * 100) / progressEvent.total
                  ) - 1;
              }).bind(this),
            }
          )
          .then((d) => {
            if (d.status == 200) {
              this.myFile.isUploaded = true;
              this.myFile.uploadPercentage = 100;
              this.myFile.striped = false;
              this.myFile.variant = "success";
              this.myFile.uploadButDisable = false;
              this.uploadedFiles = d.data;
              this.addImageDialog = false;
              this.editMemberDialog
                ? (this.selectedMember.avatar = d.data.url)
                : "";
              this.toast("تصویر با موفقیت افزوده شد.", "success");

              setTimeout(() => {
                this.addImage = false;
              }, 200);
            }
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
          });
      }
    },
    dragover(event) {
      event.preventDefault();
      // Add some visual fluff to show the user can drop its files
      // if (!event.currentTarget.classList.contains("bg-green-300")) {
      // event.currentTarget.classList.remove("bg-gray-100");
      // event.currentTarget.classList.add("bg-green-300");
      // }
    },
    dragleave() {
      // Clean up
      // event.currentTarget.classList.add("bg-gray-100");
      // event.currentTarget.classList.remove("bg-green-300");
    },
    drop(event) {
      event.preventDefault();
      this.file = event.dataTransfer.files;
      if (Array.from(this.file).length) {
        if (
          this.addLogoImage ||
          this.addMemberDialog ||
          this.editMemberDialog
        ) {
          if (Array.from(this.file).length > 1) {
            this.toast(
              " در این بخش شما مجاز به آپلود بیش از یک عکس نمی‌باشید.",
              "error"
            );
            return;
          }
        }
        Array.from(this.file).forEach((file) => {
          this.addLogoImage
            ? this.logoUpload(file)
            : this.addMemberDialog || this.editMemberDialog
            ? this.uploadMemberImage(file)
            : this.uploadImage(file);
        });
      }
      // Clean up
      // event.currentTarget.classList.add("bg-gray-100");
      // event.currentTarget.classList.remove("bg-green-300");
    },
    getStatesAndCities() {
      this.$http
        .get(this.baseUrl + "/setad/options/states/list", {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("userId"),
          },
        })
        .then((res) => {
          this.iran = res.data;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    passStrength() {
      this.has_number = /\d/.test(this.uniPassword);
      this.has_lowercase = /[a-z]/.test(this.uniPassword);
      this.has_uppercase = /[A-Z]/.test(this.uniPassword);
    },
    openAdd3() {
      // NOTE (m-openAdd3) to show loading
      this.$refs["add3"].show();
    },
    openAddCat() {
      this.$refs["addCat"].show();
    },
    openRemoveCat() {
      this.$refs["removeCat"].show();
    },
    closeRemoveCat() {
      this.$refs["removeCat"].hide();
    },
    justEng(str) {
      if (!/^[a-zA-Z0-9]+$/.test(str.key)) {
        str.key != "Backspace" && str.key != "Tab" ? str.preventDefault() : "";
      }
    },
    doAdd3() {
      this.$bvModal.show("loading");
      this.isLoaded = false;
      // NOTE (m-doAdd3) to add new subject
      this.$http
        .post(
          this.baseUrl + "/setad/admin/newMehvar",
          {
            catId: this.newMehvarMozou,
            name: this.newMehvar,
            date: this.newMehvarDate,
            contract_no: this.newMehvarNumber,
            universityId: this.$route.params.id,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.newMehvar = "";
          this.newMehvarMozou = "";
          this.newMehvarNumber = "";
          this.newMehvarDate = "";
          this.toast(res.data, "success");
          this.newMehvar = "";
          this.$refs["add3"].hide();
          this.$bvModal.hide("loading");

          setTimeout(() => {
            this.getUniversityData();
          }, 200);
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          this.$bvModal.hide("loading");
          this.isLoaded = true;
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            // else this.$router.replace("/unauthorize");
            else
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          }
        });
    },
    changePassword() {
      // NOTE (m-changePassword) to change the password
      if (
        this.has_number &&
        this.has_lowercase &&
        this.has_uppercase &&
        this.uniPassword.length > 7
      ) {
        this.isBusy = true;
        this.$http
          .post(
            this.baseUrl + "/setad/admin/university/changePassword",
            {
              universityId: this.$route.params.id,
              password: md5(this.uniPassword),
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.isBusy = false;
            this.toast(res.data, "success");
            this.uniPassword = "";
            this.uniRepeatPassword = "";
            this.has_uppercase = false;
            this.has_lowercase = false;
            this.has_number = false;
          })
          .catch((err) => {
            this.isBusy = false;

            console.log(err);
            this.toast(err.response.data, "error");
          });
      } else {
        this.toast(
          "لطفا جهت حفظ امنیت اطلاعات خود موارد خواسته شده را در رمز خود اعمال کنید",
          "error"
        );
      }
    },
    openAddMemberDialog() {
      this.addMemberDialog = true;
      this.newMember = {};
      this.uploadedFiles = {
        url: "",
        id: "",
      };
      this.selectedMember = {};
    },
    addMember() {
      this.busy = true;
      this.$http
        .post(
          this.baseUrl + "/setad/admin/university/addScienceCommittee",
          {
            universityId: this.$route.params.id,
            avatarId: this.uploadedFiles ? this.uploadedFiles.id : "",
            name: this.newMember.name,
            natCode: this.newMember.natCode,
            degree: this.newMember.degree,
            email: this.newMember.email,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.busy = false;
          this.addMemberDialog = false;
          this.toast(res.data, "success");
          this.update();
        })
        .catch((err) => {
          if (err.response.status == 403)
            // this.$router.replace("/unauthorize");
            this.$router.push({
              path: "/login",
              query: { return: window.location.pathname },
            });
        });
    },
    editMember() {
      this.busy = true;
      this.$http
        .post(
          this.baseUrl + "/setad/admin/university/editScienceCommittee",
          {
            scienceCommitteeId: this.selectedMember.id,
            avatarId: this.uploadedFiles ? this.uploadedFiles.id : "",
            name: this.selectedMember.name,
            natCode: this.selectedMember.natCode,
            degree: this.selectedMember.degree,
            email: this.selectedMember.email,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.busy = false;
          this.editMemberDialog = false;
          this.toast(res.data, "success");
          this.update();
        })
        .catch((err) => {
          if (err.response.status == 403)
            // this.$router.replace("/unauthorize");
            this.$router.push({
              path: "/login",
              query: { return: window.location.pathname },
            });
        });
    },
    addCatUni() {
      this.$bvModal.show("loading");
      this.isLoaded = false;
      this.$http
        .post(
          this.baseUrl + "/setad/admin/university/addCat",
          {
            universityId: this.$route.params.id,
            catId: this.universityCat,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.universityCat = "";
          this.toast(res.data, "success");
          this.$refs["addCat"].hide();
          this.$bvModal.hide("loading");

          setTimeout(() => {
            this.getUniversityData();
          }, 200);
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          this.$bvModal.hide("loading");
          this.isLoaded = true;
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            // else this.$router.replace("/unauthorize");
            else
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          }
        });
    },
    removeCatUni() {
      this.$bvModal.show("loading");
      this.isLoaded = false;
      this.$http
        .post(
          this.baseUrl + "/setad/admin/university/removeCat",
          {
            universityId: this.$route.params.id,
            catId: this.universityCatRemove.id,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.universityCat = "";
          this.toast(res.data, "success");
          this.$refs["removeCat"].hide();
          this.$bvModal.hide("loading");

          setTimeout(() => {
            this.getUniversityData();
          }, 200);
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          this.$bvModal.hide("loading");
          this.isLoaded = true;
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            // else this.$router.replace("/unauthorize");
            else
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          }
        });
    },
    submit() {
      this.isBusy = true;
      // NOTE (m-submit) to submit profiles change
      this.$http
        .post(
          this.baseUrl + "/setad/admin/university/edit",
          {
            universityId: this.$route.params.id,
            name: this.editInfo.name,
            username: this.editInfo.username,
            researchAssistant: this.editInfo.researchAssistant,
            mobile: this.editInfo.mobile,
            email: this.editInfo.email,
            stateId: this.editInfo.stateId ? this.editInfo.stateId : null,
            type: this.editInfo.type,
            address: this.editInfo.address,
            tel: this.editInfo.tel,
            cityId: this.editInfo.cityId ? this.editInfo.cityId : null,
            website: this.editInfo.website,
            postalCode: this.editInfo.postalCode,
            scienceCommitteeCounts: this.editInfo.scienceCommitteeCounts,
            bioScienceCommitteeCounts: this.editInfo.bioScienceCommitteeCounts,
            studentCounts: this.editInfo.studentCounts,
            bioStudentCounts: this.editInfo.bioStudentCounts,
            description: this.editInfo.description,
            isDistinguished: this.editInfo.isDistinguished,
            uniProjects: this.editInfo.isDistinguished
              ? this.editInfo.uniProjects
              : "",
            uniGrants: this.editInfo.isDistinguished
              ? this.editInfo.uniGrants
              : "",
            uniFurtherDescription: this.editInfo.isDistinguished
              ? this.editInfo.uniFurtherDescription
              : "",
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.toast(res.data, "success");
          this.getUniversityData();
          this.tabNumber = 0;
          document.querySelector("html").scroll({
            top: 0,
            left: 0,
            behavior: "smooth",
          });
          this.isBusy = false;
        })
        .catch((err) => {
          this.isBusy = false;
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            this.$router.push({
              path: "/login",
              query: { return: window.location.pathname },
            });
          }
        });
    },
    getCats() {
      this.$http
        .post(
          this.baseUrl + "/setad/options/cats/list",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.categories = res.data;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    getUniversityData() {
      if (window.screen.width < 850) {
        this.type = "mobile";
      } else {
        if (document.body.clientWidth < 850) {
          this.type = "mobile";
        } else {
          this.type = "desktop";
        }
      }
      this.vLoading = true;
      this.$http
        .post(
          this.baseUrl + "/setad/admin/university/getInfo",
          {
            universityId: this.$route.params.id,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.universityInfo = res.data;

          this.contanctName = this.universityInfo.contanctName;
          this.contanctRole = this.universityInfo.contanctRole;
          this.contanctMobile = this.universityInfo.contanctMobile;
          this.editInfo = JSON.parse(JSON.stringify(this.universityInfo));
          this.planItems = res.data.requests;
          this.vLoading = false;
          this.isLoaded = true;
          this.totalRows = this.universityInfo.scienceCommittee.length;
          this.universityCats = this.universityInfo.cats
            ? this.universityInfo.cats
            : [];

          if (window.screen.width < 450 || document.body.clientWidth < 450) {
            this.scienceCommitteeSize = 2;
          } else {
            this.scienceCommitteeSize = 4;
          }
          this.optionsBar.scales.y.ticks.stepSize =
            this.universityInfo.requestDetailsStepSum;
          setTimeout(() => {
            this.loaded = true;
          }, 1000);

          // this.planItems = res.data.proposals;
          // this.fileItems = res.data.university.allMehvar;

          this.fileBusy = false;
          this.fileBusy2 = false;
        })
        .catch((err) => {
          this.isLoaded = true;
          this.vLoading = false;

          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403 || 401) {
            this.$router.push({
              path: "/unauthorize",
              query: { return: window.location.pathname },
            });
          }
        });
    },
    update() {
      this.$http
        .post(
          this.baseUrl + "/setad/admin/university/getInfo",
          {
            universityId: this.$route.params.id,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.isLoaded = true;

          this.universityInfo = res.data;
          this.contanctName = this.universityInfo.contanctName;
          this.contanctRole = this.universityInfo.contanctRole;
          this.contanctMobile = this.universityInfo.contanctMobile;
          this.planItems = res.data.requests;
          this.editInfo = JSON.parse(JSON.stringify(this.universityInfo));
          this.totalRows = this.universityInfo.scienceCommittee.length;

          if (window.screen.width < 450 || document.body.clientWidth < 450) {
            this.scienceCommitteeSize = 3;
            this.optionsBar.plugins.legend.labels.font.size = "8";
            this.optionsBar.scales.x.ticks.font.size = "8";
            this.optionsBar.scales.y.ticks.font.size = "8";
          } else {
            this.scienceCommitteeSize = 4;
          }

          setTimeout(() => {
            this.loaded = true;
          }, 1000);

          // this.planItems = res.data.proposals;
          // this.fileItems = res.data.university.allMehvar;

          this.fileBusy = false;
          this.fileBusy2 = false;
        })
        .catch((err) => {
          this.isLoaded = true;

          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403 || 401) {
            this.$router.push({
              path: "/unauthorize",
              query: { return: window.location.pathname },
            });
          }
        });
    },
    editImg() {
      this.busy = true;
      this.$http
        .post(
          this.baseUrl + "/setad/admin/university/editGallery",
          {
            universityId: this.$route.params.id,
            fileId: this.selected.id,
            title: this.selected.title,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.busy = false;
          this.toast(res.data, "success");
          this.editImage = false;
          this.update();
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    changeContactInfo() {
      this.isBusy = true;
      this.$http
        .patch(
          this.baseUrl +
            "/setad/admin/university/changeContactInfo/" +
            this.$route.params.id,
          {
            contanctName: this.contanctName,
            contanctRole: this.contanctRole,
            contanctMobile: this.contanctMobile,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.isBusy = false;
          this.toast(res.data, "success");
          this.update();
        })
        .catch((err) => {
          this.isBusy = false;

          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
  },

  mounted() {
    this.getCats();
    this.getUniversityData();
    this.getStatesAndCities();
  },
};
</script>

<style lang="scss">
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
.modal-card {
  height: 100%;
  .upload-box {
    padding: 20px;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='9' ry='9' stroke='rgb(6, 141, 157)' stroke-width='2' stroke-dasharray='5' stroke-dashoffset='5' stroke-linecap='butt'/%3e%3c/svg%3e");
  }
  .textField-box2 {
    .v-text-field__details {
      display: none;
    }
    .v-text-field .v-input__slot,
    .v-text-field fieldset {
      border-radius: 6px !important;
      border-color: #068d9d !important;
    }
    .v-input__slot {
      min-height: 48px !important;
      margin-bottom: 25px;
      input {
        color: #656a81 !important;
      }
      .v-text-field__suffix {
        color: #656a81 !important;
      }
    }
  }
  .file-icon {
    path {
      stroke: #068d9d;
    }
  }
}
.addMember-modalCard {
  img {
    width: 100px;
    height: 100px;
    border-radius: 50%;
  }
  .profile-box {
    position: relative;
    .edit-image {
      position: absolute;
      bottom: 3px;
      right: 0px;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      svg {
        transform: translate(4px, 8px) !important;
      }
      path {
        stroke: #fff;
      }
    }
  }
}
.show-modalCard {
  border-radius: 10px !important;
  img {
    width: 100%;
    height: 100%;
    border-radius: 5px;
  }
}
.delete-modalCard {
  img {
    width: 200px;
    height: 100%;
    border-radius: 3px;
  }
}
.uploadPercentage {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  background-color: rgba(19, 18, 18, 0.726);
  text-align: center;
  z-index: 70;
  padding: 10px;
  span {
    color: whitesmoke;
    margin: auto;
    font-size: 0.9rem;
  }
}
.university {
  .imageBox {
    width: 15vw;
    height: 15vw;
    margin-bottom: 10px;
    img {
      width: 100%;
      height: 100%;
      border-radius: 3px;
    }
  }
  @media only screen and (max-width: 900px) {
    .imageBox {
      width: 30vw;
      height: 30vw;
    }
  }
  .uni-view {
    background-color: #f2f2f5;
  }
  .gallery-imageBox {
    margin: 20px auto;
    height: 210px;
    cursor: pointer;
    position: relative !important;
    border-radius: 3px;
    .image-title {
      width: 100%;
      text-align: right;
      color: #fff;
      padding: 13px;
      position: absolute;
      bottom: 0;
      left: 0;
      background-color: rgba(0, 0, 0, 0.5);
      z-index: 91;
      path {
        stroke: #fff;
      }
    }
    .v-image {
      width: 100%;
      height: 100%;
    }
    .hover-box {
      position: absolute;
      top: 0;
      left: 0;
      background-color: rgba(0, 0, 0, 0.5);
      z-index: 90;
      width: 100%;
      height: 100%;
      display: none;
      color: #fff !important;
      path,
      circle {
        stroke: #fff !important;
      }
      div {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        padding: 20px;
        background-color: rgba(0, 0, 0, 0.6);
        border-radius: 7px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
    }
    &:hover {
      .hover-box {
        display: block;
      }
    }
  }
}

.professor-img {
  border-radius: 50%;
  border: 1px solid rgb(182, 182, 182);
  width: 90px !important;
  height: 90px;
}

.center-col {
  display: flex;
  justify-content: center;
  align-items: center;
}

.see-btn {
  box-shadow: none;
  text-decoration: none !important;
  background-color: transparent !important;
  span {
    color: #068d9d;
  }
}

.gallery-img {
  width: 160px;
  height: 160px;
  border-radius: 5px;
}
.company-img {
  width: 160px;
  height: 105px;
  border-radius: 3px;
}

.img-col {
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.v-application--wrap {
  min-height: auto !important;
}

.carousel-text {
  color: white;

  margin-bottom: 10px;
  margin-top: 10px;
}

.slider-text {
  width: 100%;
  display: flex;
  justify-content: center;
  //align-items:flex-end;
}
.v-responsive__content {
  display: flex;
  justify-content: center;
  align-items: flex-end;
}

.v-carousel {
  border-radius: 10px !important;
}

.v-window__prev,
.v-window__next {
  span {
    color: #068d9d !important;
  }
}

.stretch-col {
  display: flex !important;
  flex-direction: column !important;
  justify-content: space-between !important;
  .first-card {
    height: 18% !important;
    display: flex;
    align-items: center;
  }
  .second-card {
    height: 78% !important;
  }
}

.company-stretch {
  height: 100% !important;
}

.progress-circle {
  color: #068d9d;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
.logo-box {
  width: 70px;
  height: 70px;
  margin-top: 5px;
  img {
    width: 100%;
    height: 100%;
  }
}
.view-imageBox {
  width: 165px;
  height: 165px;
  margin-bottom: 10px;
  img {
    width: 100%;
    height: 100%;
    border-radius: 3px;
  }
}
@media only screen and (min-width: 600px) {
  .description-box {
    width: calc(100% - 170px);
  }
}
.seeMore-btn {
  position: absolute;
  bottom: 15px;
  left: 15px;
}
@media only screen and (max-width: 600px) {
  .seeMore-btn {
    position: absolute;
    bottom: 10px;
    left: 15px;
  }
}
</style>
<style lang="scss" scoped>
.color {
  background-color: #0c4961;
  color: white;
}

/* pass validation style */
.pass {
  font-size: 13px;
}
.pass--passed {
  color: #717b85;
}
.frmIcon {
  color: #eb0029;
}
.pass--passed .frmIcon {
  color: #0fa140;
}
.required {
  color: red;
}

.done {
  color: green;
}
</style>
